{
    "Api tokens": {
        "add token": "Aggiungi token",
        "description": "Genera un token API per il download di file OEM per TCT e Configurator o un token API che l'applicazione utilizza quando richiede servizi FOTA WEB. La documentazione API è disponibile <1>qui</1>.",
        "example": "Esempio: fota_token",
        "generate token": "Genera token",
        "generated token": "Token generato",
        "last used at": "Utilizzato l'ultima volta alle",
        "name": "Nome token",
        "never": "Mai",
        "no tokens": "Nessun token disponibile",
        "no tokens description": "Una volta aggiunti, i token saranno elencati qui sotto",
        "show token list": "Mostra elenco token",
        "titles": {
            "Integration": {
                "description": "Utilizzato per l'integrazione FOTA WEB nel vostro sistema",
                "name": "Token di integrazione API"
            },
            "Tct": {
                "description": "Utilizzato per il download di file OEM per TCT e Configurator",
                "name": "Token TCT"
            }
        },
        "tokens": "Token API",
        "token type": "Tipo di token",
        "token was created": "Il token è stato creato con successo"
    },
    "Attributes": {
        "Completed": "Completato",
        "Count": "Conta",
        "Current": "Attuale",
        "Date": "Data",
        "Empty": "Vuoto",
        "excluded files": "File esclusi (samegrade)",
        "Failed": "Non riuscito",
        "false": "",
        "Feature": "Caratteristiche",
        "file size bytes": "Dimensione totale dei file",
        "File_type": "Tipo di file",
        "File_version": "Versione del file",
        "Fingerprint_id": "Identificazione tramite impronta digitale",
        "Firmware_date": "Data del firmware",
        "Firmware_version": "Revisione",
        "included files": "File inclusi",
        "Include_j1939": "",
        "Message": "Messaggio",
        "Metadata": "",
        "newest": "Dalle novità",
        "oldest": "Dal più vecchio",
        "Order": "Ordina",
        "Password_source": "",
        "Pending": "In attesa di approvazione",
        "Period": "Periodo",
        "Process_id": "",
        "Protocol_id": "ID protocollo",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Specifico",
        "Start": "Avvia",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Firmware BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Firmware CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Firmware TAPP"
        },
        "UserEntered": "",
        "vehicle": "Veicolo",
        "Vehicle_id": "ID veicolo",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Controlla la tua app di autenticazione",
            "check email": "Controlla la tua e-mail",
            "code required": "Codice di verifica richiesto.",
            "code sent to email": "Codice inviato alla tua email",
            "code valid": "Il codice è valido per alcuni minuti.",
            "enter code below": "e inserisci il codice sottostante per accedere.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "È richiesto un codice di verifica. Controlla la tua app di autenticazione e inserisci il codice qui sotto per accedere.",
        "check email": "Controlla la tua casella di posta elettronica e clicca sul link ricevuto per reimpostare la password.",
        "community forum": "Forum di supporto collettivo",
        "contact us": "Contattaci",
        "create initial password": "Crea password",
        "create password": "Crea una password che",
        "did not receive": "Non hai ricevuto il link?",
        "do not have account": "Non hai ancora un account?",
        "email": "E-mail",
        "enter email": "Inserisci qui sotto l'indirizzo e-mail registrato per ricevere le istruzioni per reimpostare la password.",
        "forgot password": "Hai dimenticato la password?",
        "forgot your password": "Hai dimenticato la password?",
        "for ms365": "Per gli utenti Teltonika MS365",
        "invalid email format": "Formato e-mail non valido",
        "invalid password format": "Formato password non valido",
        "link sent": "Il link è stato inviato!",
        "length": "Minimo 8 caratteri",
        "lowercase": "Contiene almeno 1 lettera minuscola",
        "new password": "Nuova password",
        "password": "Password",
        "passwords do not match": "Le password non corrispondono",
        "privacy policy": "Utilizzando FOTA WEB, accetti la nostra <1>Informativa sulla privacy</1>.",
        "remember password": "Ricordi la tua password?",
        "repeat password": "Ripeti password",
        "required": "Richiesto",
        "resend": "Invia nuovamente",
        "reset password": "Reimposta password",
        "send reset link": "Invia link di reimpostazione",
        "sign in": "Accedi",
        "sign in to fota": "Accedi al tuo account FOTA WEB",
        "signup": "Iscriviti",
        "sso": "Accedi con Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Lettera maiuscola",
        "user consent text": "Comprendo e accetto i <1>Termini di servizio</1> e l'<2>Accordo sul trattamento dei dati</2> di Teltonika.",
        "welcome": "Benvenuti su",
        "wiki": "Wiki Telematica Knowledge Base"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Accetta",
        "accept all": "Accetta tutto",
        "accept selected": "Accetta selezionati",
        "actions": "Azioni",
        "add": "Aggiungi",
        "add device": "Aggiungi dispositivo",
        "add more files": "Aggiungi altri file",
        "add new": "Aggiungi nuovo",
        "agree": "Accetto",
        "all companies": "Tutte le aziende",
        "all of company": "Tutto {{companyName}}",
        "all rows selected": {
            "devices": "Tutti i {{count}} dispositivi sono selezionati",
            "tasks": "Tutte le {{count}} attività in sospeso/in esecuzione sono selezionate",
            "groups": "Tutti i {{count}} gruppi sono selezionati",
            "files": "Tutti i {{count}} file sono stati selezionati",
            "companies": "Sono state selezionate tutte le {{count}} aziende",
            "users": "Tutti gli {{count}} utenti sono selezionati"
        },
        "approve": "Approvare",
        "assign": "Assegna",
        "assigning": "Assegnazione",
        "auto sync": "",
        "back": "Indietro",
        "back to sign in": "Torna alla pagina di accesso",
        "cancel": "Annulla",
        "cancelling": "Annullamento",
        "cancel all tasks in group": "Annulla tutte le attività nel gruppo",
        "cancel tasks": "Annulla attività",
        "cannot create desktop licenses": "Non è possibile creare licenze per aziende interne.",
        "cannot create offline licenses": "Non è possibile creare licenze offline per licenze senza restrizioni.",
        "change": "Modifica",
        "clear all": "Cancella tutto",
        "clear all filters": "Cancella tutti i filtri",
        "close": "Chiudi",
        "company settings": "Impostazioni aziendali",
        "confirm": "Conferma",
        "continue": "Continua",
        "copied": "Copiato",
        "copy all": "",
        "copy to clipboard": "Copia negli appunti",
        "create": "Crea",
        "create role": "Crea ruolo",
        "create task": "Crea attività",
        "creating": "Creazione",
        "default view": "Visualizzazione predefinita",
        "delete": "Elimina",
        "deleting": "Eliminazione",
        "deselect all": "Deseleziona tutto",
        "device": "Dispositivo",
        "disable": "Disattiva",
        "disagree": "Non sono d'accordo",
        "discard": "Elimina",
        "download": "",
        "edit": "Modifica",
        "enable": "Abilita",
        "export": "Esporta",
        "exporting": "Esportazione",
        "filters": "Filtri",
        "finish": "",
        "find tool": "Trova strumento",
        "first page": "Prima pagina",
        "generate": "Genera",
        "generate codes": "",
        "go back": "Torna indietro",
        "import": "Importa",
        "importing": "Importazione",
        "invite": "Invita",
        "invite user": "Invita utente",
        "invite user to internal disabled": "Solo l'amministratore e gli utenti con livelli di accesso superiori possono invitare altri utenti all'interno dell'azienda.",
        "language": "Lingua",
        "last page": "Ultima pagina",
        "logout": "Esci",
        "maximize details": "Massimizza i dettagli",
        "merge": "Unisci",
        "merging": "Unione",
        "minimize details": "Riduci al minimo i dettagli",
        "more actions": "Altre azioni",
        "more filters": "Altri filtri",
        "more options": "Altre opzioni",
        "move": "Sposta",
        "moving": "Trasferimento",
        "next": "Avanti",
        "next month": "Il mese prossimo",
        "next page": "Pagina successiva",
        "no actions available": "Nessuna azione disponibile",
        "no permission": "È necessaria l'autorizzazione \"{{permissionName}}\".",
        "no permissions": "Sono necessarie le seguenti autorizzazioni: {{permissionNames}}.",
        "notify when done": "Avvisami quando hai finito",
        "number of selected companies": "{{companyCount}} di {{companyName}}",
        "only essential": "Solo l'essenziale",
        "open fota web": "Open FOTA WEB",
        "pages of": "di {{total}}",
        "previous month": "Mese precedente",
        "previous page": "Pagina precedente",
        "print": "",
        "receive devices": "Ricezione dispositivi",
        "refresh page": "Aggiorna",
        "reject all": "Rifiuta tutto",
        "reset to default": "Ripristina impostazioni predefinite",
        "retry failed tasks": "Riprova le attività non riuscite",
        "retrying": "Riprova",
        "return home": "Andiamo a casa",
        "revert manual level change": "Ripristina modifica manuale del livello",
        "rows count per page": "Numero di righe per pagina",
        "rows selected": "{{count}} Selezionato",
        "save": "Salva",
        "saving": "",
        "see all": "Vedi tutto",
        "select all": {
            "devices": "Seleziona tutti i {{count}} dispositivi",
            "tasks": "Seleziona tutte le {{count}} attività in sospeso/in esecuzione",
            "groups": "Seleziona tutti i {{count}} gruppi",
            "files": "Seleziona tutti i {{count}} file",
            "companies": "Seleziona tutte le {{count}} aziende",
            "users": "Seleziona tutti gli {{count}} utenti"
        },
        "select columns to show": "Seleziona le colonne da visualizzare",
        "selected page is first": "La pagina selezionata è la prima",
        "selected page is last": "La pagina selezionata è l'ultima",
        "select rows": "Seleziona righe",
        "send code": "Invia codice",
        "settings": "Impostazioni",
        "show me": "Mostrami",
        "show more": "Mostra altro",
        "synchronize": "Sincronizza",
        "table statistics": "Statistiche",
        "table view": "Visualizzazione tabella",
        "transfer": "Trasferimento",
        "transferring": "Trasferimento",
        "transfer my devices": "Trasferisci i miei dispositivi",
        "undo": "Annulla",
        "upload": "Carica",
        "upload file": "Carica nuovo file",
        "user": "Utente",
        "verify": "Verifica",
        "yes": "Sì"
    },
    "Cookies": {
        "always active": "Sempre attivo",
        "analytics cookies": "Cookie analitici",
        "analytics cookies description": "Questi tracker vengono utilizzati per analisi che aiutano a raccogliere dati che ci consentono di comprendere come gli utenti interagiscono con i nostri siti web. Queste informazioni ci consentono sia di migliorare i contenuti sia di sviluppare funzionalità migliori che migliorano l'esperienza dell'utente. Questa categoria di cookie può essere disabilitata.",
        "cookie banner message": "Noi e terze parti selezionate utilizziamo cookie o tecnologie simili per scopi tecnici e, con il tuo consenso, per altri scopi specificati nella ",
        "cookie modal title": "Utilizziamo i cookie",
        "cookie policy": "Politica sui cookie",
        "essential cookies": "Cookie essenziali",
        "essential cookies description": "Questi tracker vengono utilizzati per attività strettamente necessarie al funzionamento o alla fornitura del servizio da voi richiesto e non raccolgono informazioni su di voi che potrebbero essere utilizzate per scopi di marketing, né ricordano i siti che avete visitato su Internet. Questa categoria di cookie non può essere disabilitata."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Elementi essenziali per l'aggiornamento remoto dei dispositivi",
                "Standard": "Automazione e integrazione avanzate",
                "Premium": "Scalabilità aziendale e accesso anticipato agli aggiornamenti"
            },
            "resource limit types": {
                "Companies": "Aziende",
                "Users": "Utenti",
                "ConfigurationFiles": "File di configurazione"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Non appena le configurazioni vengono rilevate da FOTA WEB, potrai visualizzare l'elenco qui.",
                "firmware versions": "Non appena le versioni del firmware vengono rilevate da FOTA WEB, potrai visualizzare l'elenco qui."
            },
            "title": {
                "configurations": "Nessuna configurazione rilevata",
                "firmware versions": "Nessuna versione firmware rilevata",
                "news": "Nessuna notizia da mostrare"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Oggi",
                "7": "7 giorni",
                "30": "30 giorni",
                "90": "90 giorni"
            },
            "period": "Periodo"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Desideriamo ricordare che per gli utenti invitati dopo il 7 gennaio 2025, l'autenticazione a due fattori (2FA) sarà obbligatoria immediatamente dopo l'attivazione dell'account. L'autenticazione a due fattori è disponibile tramite verifica e-mail o app di autenticazione.",
                "2": "Desideriamo informarvi della manutenzione programmata di FOTA WEB che avrà luogo il 3 giugno 2025 a partire dalle 05:00 UTC. Si prega di tenere presente che durante la manutenzione tutti i servizi saranno indisponibili, compresi l'interfaccia utente, l'accesso alle API, l'esecuzione delle attività, i servizi OBD e CAN. Il tempo stimato di indisponibilità del servizio è di 1 ora.",
                "3": "<section><p>Siamo lieti di annunciare un importante miglioramento alla funzione Device Unlocker su FOTA WEB:</p></section> <section><p>Tutti i ruoli utente possono ora sbloccare direttamente i dispositivi, senza bisogno di contattare il supporto tecnico tramite l'helpdesk!</p> <p>Dettagli chiave:</p> <ul><li>Gli utenti possono sbloccare lo stesso dispositivo fino a 3 volte in un periodo di 24 ore.</li> <li>Una volta raggiunto il limite, l'opzione di sblocco sarà temporaneamente disabilitata per 24 ore.</li> <li>Se il limite di sblocco viene superato, verrà visualizzato un messaggio di errore. Questo aggiornamento riduce significativamente i tempi di attesa e offre un maggiore controllo sulla gestione della flotta.</li></ul></section> <section><a>Scopri come utilizzare la funzione</a></section>",
                "4": "<section><h3>Nuove statistiche sui dispositivi</h3> <p>Ottenete informazioni più dettagliate sull'attività dei vostri dispositivi con due nuovissimi widget:</p> <p><strong>Dispositivi attivati</strong>: Questa nuova statistica mostra quanti dispositivi sono stati attivati (connessi) in vari periodi: oggi, 7 giorni, 30 giorni o 90 giorni. </p> <p><strong>Dispositivi importati</strong>: analogamente, la nuova statistica Dispositivi importati tiene traccia di quanti dispositivi sono stati importati oggi, negli ultimi 7 giorni, 30 giorni o 90 giorni.</p> </section> <section><h3>Presentazione del widget Attività</h3> <p>Tieni traccia delle tue operazioni con il nuovissimo widget Attività:</p> <p><strong>Attività in coda</strong>: visualizza un conteggio chiaro delle attività attualmente in sospeso.</p> <p><strong>Panoramica delle attività</strong>: ottieni una ripartizione della distribuzione delle attività per periodo (7 giorni, 30 giorni o 90 giorni) e stato. Ciò include le attività completate, completate con errori o non riuscite.</p></section> <section><h3>Panoramica più intelligente del firmware e delle configurazioni</h3> <p>Abbiamo perfezionato i widget Versioni firmware e Configurazioni:</p> <ul><li>Abbiamo rimosso le statistiche \"Sconosciute\" per ottenere dati più chiari.</li> <li>L'interfaccia utente ora mostra in modo più chiaro i nomi del firmware e delle configurazioni e il loro conteggio.</li> <li>Inizialmente vedrai le prime 5 versioni o configurazioni, con un'opzione \"Mostra altro\" per visualizzare fino a 100 voci diverse. </li> <li>Passando con il mouse e cliccando su un firmware o una configurazione specifica, verrai reindirizzato alla \"pagina Dispositivi\" e verrà applicato un filtro.</li></ul></section> <section><h3>Widget Notizie migliorato</h3> <p>Rimani informato a colpo d'occhio! Il widget Notizie ha un nuovo look e ora puoi anche cliccare su qualsiasi notizia per leggere tutte le informazioni. </p></section> <section><h3>Stato del dispositivo migliorato</h3> <p>Il widget Stato del dispositivo è stato aggiornato visivamente per una maggiore chiarezza. Inoltre, ora puoi passare con il mouse sullo stato di un dispositivo e cliccarci sopra per filtrare i dispositivi con lo stato corrispondente nella pagina \"Dispositivi\".</p></section> <section><p>Ci auguriamo che questi aggiornamenti rendano le tue attività quotidiane ancora più semplici e ti forniscano informazioni più preziose. Facci sapere cosa ne pensi!</p></section>",
                "5": "<section><h3>Modifiche API previste</h3></section> <section><p>Il <strong>24 settembre 2025</strong> rimuoveremo il campo \"ruolo\" dalle risposte che restituiscono l'entità utente (ad esempio, endpoint GET /users o GET /users/{userId}). Questa modifica è stata apportata per consentire l'implementazione di un sistema di autorizzazioni più solido e flessibile in FOTA WEB.</p></section> <section><h3>Anteprima: ruoli e autorizzazioni</h3></section> <section><p> Siamo consapevoli che l'attuale sistema di ruoli non offre la flessibilità di cui avete bisogno. Il nostro team di sviluppo sta lavorando alacremente a una nuova funzione di <strong>gestione dei ruoli e delle autorizzazioni</strong> che vi consentirà di creare ruoli con un controllo granulare delle autorizzazioni.</p></section> <section><p>Questo nuovo sistema vi darà la possibilità di assegnare ruoli statici agli utenti o di personalizzare le autorizzazioni in base alle vostre esigenze specifiche e di creare ruoli personalizzati. Siamo molto entusiasti di questa novità e non vediamo l'ora di condividere ulteriori dettagli sulla gestione dei ruoli e delle autorizzazioni non appena saranno disponibili.</p></section>",
                "6": "<section><p>Siamo lieti di annunciare il rilascio della nuova funzione <strong>\"Ruoli e autorizzazioni\"</strong>, progettata per offrirti un controllo preciso sull'accesso degli utenti all'interno di FOTA WEB. Questa funzionalità ti consente di definire le capacità degli utenti utilizzando i <strong>Ruoli</strong>, che sono insiemi di <strong>Autorizzazioni</strong> specifiche (ad esempio, \"Crea attività\", \"Invita utente\"). La funzione include <strong>ruoli statici</strong> immutabili - Amministratore, Utente e Ospite - per la sicurezza di base, insieme a <strong>ruoli personalizzati</strong> che solo gli utenti <strong>di livello aziendale Premium</strong> possono creare o modificare. Le autorizzazioni sono ora classificate in aree chiave come Dispositivi, Attività e Utenti e possono essere visualizzate passando con il mouse su \"Conteggio autorizzazioni\" nella sezione di gestione. <strong>A tutti gli utenti esistenti creati prima di questo aggiornamento è stato automaticamente assegnato il ruolo di \"Amministratore\", garantendo loro di mantenere l'intera gamma di azioni che potevano eseguire in precedenza. </strong></p></section> <section><p>Questo aggiornamento garantisce una maggiore sicurezza e una migliore distribuzione del carico di lavoro. I ruoli sono ora specifici per ogni azienda e non possono essere ereditati tra le diverse strutture aziendali. Si noti che è necessario assegnare sempre un ruolo quando si invita o si sposta un utente in un'azienda e che i ruoli con assegnazioni utente attive non possono essere eliminati. Ora è possibile utilizzare il <strong>nuovo filtro \"Ruolo\"</strong> nella pagina <strong>Utenti</strong> per una gestione più semplice. Esplora oggi stesso la sezione \"Ruoli e autorizzazioni\" per configurare l'accesso in base alle esigenze della tua organizzazione.</p></section> <section><p>Per una guida dettagliata sulla gestione degli utenti e dei ruoli, visitare <a>la pagina wiki</a>.</p></section>",
                "7": "<section><p>Siamo lieti di presentare un nuovo potente strumento per gestire le vostre attività con la funzione <strong>Pianificazione per data</strong>, che vi offre una maggiore precisione per i lavori urgenti!</p></section> <section><h3>Caratteristiche principali</h3></section> <section><ul><li><strong>Scadenze specifiche</strong> - Ora puoi pianificare le attività per una <strong>data specifica o un intervallo di date</strong> utilizzando la nuova opzione \"Pianifica per data\".</li> <li><strong>Comportamento predefinito invariato</strong> - La familiare funzionalità <strong>Pianifica per ora</strong> rimane completamente disponibile. </li> <li><strong>Stato di scadenza</strong> - Le attività non completate entro la data impostata ora cambieranno automaticamente lo stato in <strong>Scaduta</strong>, accompagnate dal messaggio: <strong>\"L'attività non è stata completata durante il periodo pianificato.\"</strong></li> <li><strong>Tempistica incentrata sull'utente</strong> - Tutte le pianificazioni vengono create in base all'<strong>ora locale</strong>.</li></ul></section> <section><h3>Come funziona</h3></section> <section><p>Quando si imposta l'attività <strong>\"Pianifica per data\"</strong>:</p> <ul><li>Selezionerai una <strong>\"Data di inizio\"</strong> e una <strong>\"Data di fine\"</strong> tramite il componente di selezione della data.</li> <li>Il selettore di date rispetta il limite di tempo di scadenza delle attività livello aziendale.</li></ul></section><section><p>La funzionalità <strong>Pianifica per data</strong> è attualmente esclusiva dei livelli aziendali superiori e non è disponibile per il livello <strong>Base</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Autenticazione a due fattori (2FA) obbligatoria per i nuovi utenti a partire dal 7 gennaio 2025",
                "2": "Manutenzione programmata per il 3 giugno 2025",
                "3": "Nuovo aggiornamento delle funzionalità: sblocco dei dispositivi più semplice per tutti gli utenti",
                "4": "Scopri le novità sulla tua dashboard!",
                "5": "Importante: imminenti modifiche alle API e anteprima dei ruoli e delle autorizzazioni",
                "6": "Nuova funzionalità ora disponibile: controllo avanzato con \"Ruoli e autorizzazioni\"",
                "7": "Nuova funzionalità: maggiore flessibilità con la pianificazione delle attività per data",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Pubblicato il",
        "take me there": "Vai alla sezione",
        "tasks": {
            "current": "Attuale",
            "status": {
                "completed": "Completato",
                "completed_with_errors": "Completato con errori",
                "failed": "Non riuscito",
                "no tasks": "Nessuna attività"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 giorni",
                "tooltipTitle": "Ultimi 7 giorni"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 giorni",
                "tooltipTitle": "Ultimi 30 giorni"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 giorni",
                "tooltipTitle": "Ultimi 90 giorni"
            }
        },
        "title": {
            "activated": "Dispositivi attivati",
            "configurations": "Configurazioni",
            "device status": "Stato del dispositivo",
            "firmware versions": "Versioni del firmware",
            "imported": "Dispositivi importati",
            "news": "Notizie",
            "queued tasks": "Attività in coda",
            "refreshed every hour": "Aggiornato ogni ora",
            "resource limits": "Limiti delle risorse",
            "task overview": "Panoramica delle attività",
            "tasks": "Attività"
        },
        "tooltips": {
            "activated": "Numero di dispositivi che si sono connessi a FOTA WEB per la prima volta durante il periodo selezionato (oggi, ultimi 7 giorni, ultimi 30 giorni, ultimi 90 giorni).",
            "configurations": "Mostra l’elenco dei file di configurazione che sono stati caricati sui tuoi dispositivi. Vengono visualizzati fino a 100 nomi di file univoci.",
            "firmware versions": "Visualizza l’elenco delle versioni del firmware segnalate dai dispositivi collegati. Vengono mostrate fino a 100 versioni uniche.",
            "imported": "Numero di dispositivi aggiunti al tuo account durante il periodo selezionato (oggi, ultimi 7 giorni, ultimi 30 giorni, ultimi 90 giorni)."
        }
    },
    "Date picker": {
        "disableFuture": "Data non valida",
        "disablePast": "Data non valida",
        "invalidDate": "Data non valida",
        "maxDate": "Data errata",
        "minDate": "Data errata",
        "shouldDisableDate": "Data non valida",
        "shouldDisableMonth": "Data non valida",
        "shouldDisableYear": "Data non valida"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Aggiungi nuovo dispositivo",
        "add new device description": "Aggiungi uno o più nuovi dispositivi all'azienda e al gruppo selezionati. Solo i dispositivi legacy, come FM o FMA, devono essere importati selezionando la casella di controllo \"Importa come dispositivi legacy\".",
        "add new device legacy title": "Importazione come dispositivi legacy.",
        "add new device legacy description": "Imposta \"Creato il\" su 2016.01.01 e \"Modello\" su Legacy.",
        "add new product code": "Aggiungi nuovo codice prodotto",
        "add new product code description": "Aggiungi un nuovo codice prodotto del dispositivo e collegalo al pacchetto CAN disponibile.",
        "all permissions": "Tutte le autorizzazioni",
        "assign access group": "",
        "assign can package description": "Scegli un tipo di pacchetto e assegnalo a tutti i dispositivi selezionati.",
        "assign role": "Assegnazione dei ruoli",
        "attribute value": "Valore dell'attributo",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Avvia download",
        "by date": "Per data",
        "by time": "Per orario",
        "can adapter": "Adattatore CAN",
        "cancel pending tasks": "Annulla le attività in sospeso dello stesso tipo di attività",
        "cancel tasks": "Annulla attività",
        "cancel tasks in group": {
            "alert title": "Questa operazione richiederà alcuni minuti per essere completata.",
            "banner description": "Per visualizzare lo stato aggiornato delle attività, consultare i dettagli del gruppo di attività o aggiornare la pagina.",
            "banner title": "Questa operazione richiederà alcuni minuti per essere completata, a seconda del numero di attività.",
            "description": "Cliccando su \"Accetta\" verranno annullate tutte le attività in sospeso e in esecuzione. Sei sicuro di voler procedere?",
            "title": "Annullare tutte le attività nel gruppo?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "E-mail del rappresentante del cliente",
        "companies": "Aziende",
        "company": "Azienda",
        "company level": {
            "Basic": "Base",
            "Internal": "Interno",
            "Premium": "Premium",
            "Standard": "Standard"
        },
        "company level change description": "È possibile aggiornare il livello di un'azienda selezionando il nuovo livello e fornendo una spiegazione del motivo. Non è possibile effettuare il downgrade del livello di un'azienda. Tutte le date sono espresse in UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Questa azione ripristinerà il livello aziendale al livello assegnato automaticamente \"{{companyLevel}}\". Sei sicuro di voler continuare?",
                "title": "Ripristinare la modifica manuale del livello?"
            },
            "description": "Il ripristino riporterà il livello aziendale al livello assegnato automaticamente.",
            "title": "Questo livello aziendale è stato aggiornato manualmente fino al {{expirationDate}}."
        },
        "company level type": "Tipo livello aziendale",
        "company name": "Nome dell'azienda",
        "company statistics": {
            "child companies": "Numero di società controllate",
            "devices": "Numero di dispositivi",
            "files": "Numero di file",
            "groups": "Numero di gruppi di dispositivi",
            "tasks": "Numero di attività",
            "users": "Numero di utenti"
        },
        "company type": {
            "All": "",
            "Client": "Cliente",
            "Internal": "Interno",
            "Virtual": "Virtuale"
        },
        "configuration": "Configurazione",
        "confirmations": {
            "are you sure": "Sei sicuro?",
            "are you sure you wish to continue": "Sei sicuro di voler continuare?",
            "assign can package confirmation": "Sei sicuro di voler assegnare il pacchetto selezionato al numero specificato di dispositivi?",
            "cancel task confirmation": {
                "first part": "Sei sicuro di voler annullare il numero specificato di attività?",
                "second part": "In tal caso, inserisci il numero di attività interessate e clicca su \"Conferma\"."
            },
            "create task confirmation": "Sei sicuro di voler creare un'attività per il numero specificato di dispositivi?",
            "delete resource confirmation": {
                "first part": "Sei sicuro di voler eliminare il numero specificato di {{resource}}?",
                "second part": "In tal caso, inserisci il numero di {{resource}} interessati e clicca su \"Elimina\"."
            },
            "delete resources": {
                "companies": "aziende",
                "files": "file",
                "groups": "gruppi di dispositivi",
                "deviceModels": "modelli",
                "productCodes": "codici prodotto",
                "roles": "ruoli",
                "users": "utenti"
            },
            "description second part": "In tal caso, inserisci il numero di dispositivi interessati e clicca su \"Conferma\".",
            "export device data confirmation": "Sei sicuro di voler esportare i dati dei dispositivi per il numero specificato di dispositivi?",
            "file": "Inserisci il numero di righe presenti nel file",
            "filter": {
                "companies": "Inserisci il numero di aziende filtrate",
                "devices": "Inserisci il numero di dispositivi filtrati",
                "files": "Inserisci il numero di file filtrati",
                "groups": "Inserisci il numero di gruppi di dispositivi filtrati",
                "productCodes": "Inserisci il numero di codici prodotto filtrati",
                "tasks": "Inserisci il numero di attività filtrate",
                "users": "Inserisci il numero di utenti filtrati"
            },
            "id_list": {
                "companies": "Inserisci il numero di aziende selezionate",
                "devices": "Inserisci il numero di dispositivi selezionati",
                "files": "Inserisci il numero di file selezionati",
                "groups": "Inserisci il numero di gruppi di dispositivi selezionati",
                "productCodes": "Inserisci il numero dei codici prodotto selezionati",
                "tasks": "Inserisci il numero di attività selezionate",
                "users": "Inserisci il numero di utenti selezionati"
            },
            "merge companies confirmation": "Stai per fondere le società {{sourceCompany}} e {{targetCompany}}.",
            "move companies confirmation": "Stai per trasferire {{sourceCompany}} alla società {{targetCompany}}.",
            "move devices confirmation": "Sei sicuro di voler trasferire il numero specificato di dispositivi a un'altra azienda?",
            "number of lines": "Numero di righe",
            "selected 20 or more devices": "Hai selezionato 20 o più dispositivi...",
            "transfer devices confirmation": "Sei sicuro di voler trasferire il numero specificato di dispositivi a un'altra azienda?"
        },
        "confirm cannot revert": "Questa azione è irreversibile.",
        "confirm merge companies": "Sei sicuro di voler unire queste aziende?",
        "count": "Conta",
        "create company": "Crea azienda",
        "create company description": "Crea una nuova società sotto la società madre selezionata.",
        "create desktop license": "Crea licenza desktop",
        "create desktop license description": "Rilascia una nuova licenza FOTA Desktop online per l'azienda cliente con il suo IP, la chiave hardware e la scadenza (max 2 anni).",
        "create group": "Crea gruppo",
        "create group description": "Organizza i dispositivi in gruppi per semplificarne la gestione e l'assegnazione in blocco.",
        "create model": "Crea modello",
        "create model description": "Crea un nuovo modello di dispositivo specificando nome, piattaforma e supporto TCT web.",
        "create offline license": "Crea licenza offline",
        "create or edit group description": "Il firmware e la configurazione possono essere assegnati al gruppo. Una volta fatto ciò, verranno generate attività di aggiornamento del firmware e/o della configurazione per tutti i membri del gruppo (dispositivi).",
        "create role": "Crea ruolo",
        "create role description": "Crea un nuovo ruolo assegnandogli un nome e una descrizione, selezionando un'azienda e assegnando autorizzazioni specifiche.",
        "create smart group": "Crea un gruppo intelligente",
        "create smart group banner message": "",
        "create smart group description": "I file di firmware e di configurazione possono essere assegnati al gruppo per ciascuna piattaforma. Una volta assegnati i file, verranno generate attività di aggiornamento per tutti i dispositivi del gruppo.",
        "create task description first step": "Crea un'ampia varietà di attività che vanno dall'aggiornamento della configurazione o del firmware alla ricezione di log, configurazioni e altro ancora da dispositivi selezionati o filtrati. Inoltre, puoi pianificare le attività create in base alle tue esigenze.",
        "create task description last step": "Assicurati che le informazioni riportate di seguito siano corrette prima di creare l'attività.",
        "current level": "livello attuale",
        "custom resource limits": {
            "at least one limit must be higher": "Almeno un limite deve essere superiore al valore predefinito del livello Premium.",
            "configuration files per device": "File di configurazione per dispositivo",
            "confirmation modal description": "Sei sicuro di voler modificare i seguenti limiti di risorse dell'azienda \"{{companyName}}\"?",
            "confirmation modal title": "Modificare i limiti delle risorse aziendali?",
            "count": {
                "companies count": "Numero di aziende: {{number}}",
                "configuration files per device count": "Numero di file di configurazione per dispositivo: {{number}}",
                "tasks per group count": "Numero di attività per gruppo: {{number}}",
                "users count": "Numero di utenti: {{number}}"
            },
            "explanations": {
                "companies": "Il numero totale di società controllate che possono essere create nella gerarchia aziendale.",
                "configuration files per device": "Il numero di file di configurazione che possono essere memorizzati, 1 dispositivo equivale a 1 file di configurazione. Il numero minimo garantito di file di configurazione è 100 per ogni livello aziendale.",
                "tasks per group": "Numero di attività che possono essere incluse in un unico gruppo di attività.",
                "users": "Numero totale di utenti che possono essere creati nella gerarchia aziendale."
            },
            "main modal description": "Imposta una quantità personalizzata di risorse per diversi tipi di risorse come aziende, utenti, attività per gruppo di attività o file di configurazione. Le risorse personalizzate rimarranno attive fino alla scadenza del livello Premium o al ripristino manuale.",
            "resources limit type": "Tipo di limite delle risorse",
            "revert custom resource limits": "Ripristina i limiti delle risorse personalizzate",
            "revert custom resource limits description": "Il ripristino di tutti i limiti imposterà i valori predefiniti delle risorse e modificherà il livello aziendale in Premium.",
            "revert custom resource limits description confirmation": "Questa azione ripristinerà i limiti delle risorse a quelli assegnati automaticamente per il livello \"Premium\". Sei sicuro di voler continuare?",
            "revert custom resource limits title": "I limiti delle risorse di questa azienda sono stati impostati manualmente.",
            "revert custom resource limits title confirmation": "Ripristinare i limiti delle risorse personalizzate?",
            "tasks per group": "Attività per gruppo"
        },
        "date range": "Intervallo di date",
        "date to": "a",
        "delete companies": "Elimina aziende",
        "delete deviceModels": "Elimina modelli",
        "delete files": "Eliminazione dei file",
        "delete file warning": "L'eliminazione dei file cancellerà le attività e i gruppi di attività correlati.",
        "delete groups": "Elimina gruppi di dispositivi",
        "delete productCodes": "Elimina codici prodotto",
        "delete roles": "Elimina ruoli",
        "delete tasks and history": "",
        "delete users": "Eliminazione degli utenti",
        "description": "Descrizione",
        "desktop license delete description": "Sei sicuro di voler eliminare la licenza desktop \"{{name}}\"?",
        "desktop license name": "Nome della licenza desktop",
        "device identifier": "Identificatore del dispositivo",
        "device transfer": {
            "main": {
                "description": "Trasferimento di dispositivi selezionati o filtrati a un'azienda non correlata utilizzando un token generato dall'azienda ricevente.",
                "title": "Trasferimento dei dispositivi"
            },
            "receive devices": {
                "copy token": "Copia e invia il token generato alla persona responsabile del trasferimento dei dispositivi dalla sua azienda alla tua.",
                "description": "Crea un token per i dispositivi riceventi e invialo alla società di trasferimento.",
                "token info": "Il token è monouso e scade dopo 21 giorni."
            },
            "transfer devices": {
                "confirmation": "Sei sicuro di voler trasferire i dispositivi a una delle seguenti aziende?",
                "device token": "Il token di trasferimento del dispositivo deve essere richiesto al responsabile dell'azienda a cui si desidera trasferire i propri dispositivi.",
                "transfer from file": "Carica un file con l'elenco dei dispositivi (IMEI) che desideri trasferire dalla tua azienda all'azienda di cui hai appena inserito il token."
            }
        },
        "device transfer token": "Token di trasferimento dispositivo",
        "downgrading company level is not possible": "Non è possibile effettuare il downgrade a livello aziendale",
        "download sample file message": "Scarica un <1>modello CSV di esempio</1> per vedere un esempio del formato richiesto.",
        "edit group banner message": "La modifica del firmware e/o dei file di configurazione annullerà tutte le attività precedenti in sospeso dello stesso tipo.",
        "edit group description": "Modifica le impostazioni per questo gruppo di dispositivi.",
        "edit role description": "Personalizza il nome, la descrizione e le autorizzazioni del ruolo. L'azienda assegnata non può essere modificata.",
        "edit smart group description": "I file di firmware e di configurazione possono essere assegnati o modificati al gruppo per ciascuna piattaforma. Una volta assegnati o modificati i file, verranno generati compiti di aggiornamento per tutti i dispositivi del gruppo.",
        "email": "E-mail",
        "enter": "Entra",
        "enter code": "Inserisci il codice",
        "enter description": "Inserisci la descrizione",
        "enter name": "Inserisci il nome",
        "example": "Esempio:",
        "expires at": "Scade il",
        "explanation": "Spiegazione",
        "export device data": "Esportazione dei dati dei dispositivi",
        "export device description": "",
        "export file format": "Formato di esportazione dei file",
        "feature": "Caratteristiche",
        "feature control": "Controllo delle funzionalità",
        "field disabled until company selected": "Questo campo è disabilitato fino a quando non viene selezionata la Società.",
        "firmware": "Firmware",
        "files to download": "File da scaricare",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "L'elenco delle autorizzazioni 1-Wire caricato verrà automaticamente ordinato per migliorare la velocità e la precisione delle funzionalità.",
                "bluetooth_authorization_list": "L'elenco delle autorizzazioni Bluetooth caricato verrà automaticamente ordinato per migliorare la velocità e la precisione delle funzionalità."
            },
            "endings": {
                "file": "file",
                "files": "file"
            },
            "fail": {
                "multiple": "{{failCount}} su {{totalCount}} {{fileEnding}} non sono stati caricati a causa di un errore.",
                "single": "{{failCount}} su {{totalCount}} {{fileEnding}} non è stato caricato a causa di un errore."
            },
            "success": {
                "multiple": "Tutti i file sono stati aggiunti correttamente alle aziende selezionate.",
                "single": "Tutti i file sono stati aggiunti correttamente all'azienda selezionata."
            }
        },
        "filtered": "Filtrato",
        "filtered companies": "Aziende filtrate",
        "filtered devices": "Dispositivi filtrati",
        "filtered files": "File filtrati",
        "filtered groups": "Gruppi filtrati",
        "filtered tasks": "Attività filtrate",
        "filtered users": "Utenti filtrati",
        "find tool": {
            "device": {
                "error not valid": "L'IMEI deve essere composto da 15 caratteri",
                "error subtitle": "Dispositivo non trovato. Prova a digitare un altro IMEI.",
                "error title": "Nessun dispositivo trovato",
                "link": "Vai al dispositivo",
                "no permission": "Non hai il permesso di visualizzare questo dispositivo."
            },
            "user": {
                "error not valid": "Formato e-mail non valido",
                "error subtitle": "Utente non trovato. Prova a digitare un altro indirizzo e-mail utente.",
                "error title": "Nessun utente trovato",
                "link": "Vai all'utente",
                "no permission": "Non hai il permesso di visualizzare questo utente."
            }
        },
        "firmware date": "Data del firmware",
        "from form": "Dal modulo",
        "from file": "Da file",
        "general": "Generale",
        "gsm_number": "Numero GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Restrizione IMEI",
        "import device data": "Importazione dei dati dei dispositivi",
        "import device data description": "Importa i dati degli attributi selezionati per i dispositivi nell'elenco fornito.",
        "import device data info": "Ogni attributo ha un limite massimo di caratteri visualizzato tra parentesi. Se un attributo ha più caratteri del limite massimo, verrà automaticamente abbreviato fino al limite massimo.",
        "import device data limit": "(max {{limit}} caratteri)",
        "imsi": "IMSI",
        "input text too long": "Il testo è troppo lungo. È consentito un massimo di {{maxLength}} caratteri.",
        "invalid hardware key": "Formato chiave hardware non valido",
        "invalid imei": "IMEI non valido",
        "invalid ipv4": "Formato IPv4 non valido",
        "invalid serial": "Numero seriale non valido",
        "invalid value": "Valore non valido",
        "inverted selection": "Selezione invertita",
        "invite user": "Invita utente",
        "invite user description": "Invita un nuovo utente alla società madre selezionata e imposta il suo ruolo. Dopo l'invio, l'utente avrà 30 giorni di tempo per accettare l'invito prima che scada.",
        "invite user max roles": "È consentito un massimo di 5 ruoli. Deselezionarne uno per procedere.",
        "log files": "File di log",
        "make": "Crea",
        "manage permissions": "Gestisce tutti i dati a livello di account e di sito.",
        "maximum value is": "Il valore massimo è {{value}}",
        "merge companies": "Unire aziende",
        "merge companies info": "Tutte le risorse dell'azienda di origine (dispositivi, gruppi, file, aziende, utenti con i loro ruoli) saranno trasferite all'azienda di destinazione. Si consiglia di rivedere i ruoli degli utenti prima della fusione. L'azienda di origine verrà successivamente eliminata.",
        "merge companies disabled option": {
            "client to internal": "Le aziende di tipo cliente non possono essere fuse con aziende di tipo interno.",
            "internal": "Le aziende di tipo interno non possono essere unite.",
            "lz code": "Le aziende con codice non possono essere unite."
        },
        "minimum value is": "Il valore minimo è {{value}}",
        "move companies disabled option": {
            "internal": "Le aziende di tipo interno non possono essere trasferite."
        },
        "move device": "Sposta dispositivo",
        "move device description": "Sposta i dispositivi selezionati o filtrati nell'azienda esistente e/o nel gruppo nella gerarchia aziendale.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Sposta dispositivi",
        "name": "Nome",
        "newest": "Dalle novità",
        "no dropdown files": {
            "description": "Per selezionare questa opzione, carica un nuovo file $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Elenco delle autorizzazioni 1-Wire",
                "adas_firmware": "Firmware ADAS",
                "ble_fw": "Firmware BLE",
                "blue_nrg": "Firmware BlueNrg",
                "bluetooth_authorization_list": "Elenco delle autorizzazioni Bluetooth",
                "can_chip_firmware": "Firmware del chip FM CAN",
                "carrier_advance_firmware": "Firmware Carrier Advance",
                "carrier_advance_settings": "Impostazioni Carrier Advance",
                "carrier_apx_firmware": "Firmware Carrier APX",
                "carrier_apx_settings": "Impostazioni Carrier APX",
                "certificate": "Certificato TLS",
                "configuration": "configurazione",
                "dsm_firmware": "Firmware DSM",
                "dtb": "DTB",
                "firmware": "firmware",
                "fw_bundle": "pacchetto firmware",
                "gnssm_download_assistant": "Assistente di download GNSS-M",
                "gnssm_firmware": "Firmware GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Elenco manuale degli scenari di geofence",
                "meig_modem_firmware": "Firmware del modem MeiG",
                "netprisma_modem_firmware": "Firmware del modem NETPRISMA",
                "psub": "Abbonamento",
                "quectel_modem_firmware": "Firmware del modem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Non ci sono file $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Nessuno",
        "obd oem": "OBD OEM",
        "offline license delete description": "Sei sicuro di voler eliminare la licenza offline \"{{name}}\"?",
        "oldest": "Dal più vecchio",
        "only integers": "Sono validi solo i numeri interi",
        "only numbers": "Sono validi solo i numeri",
        "optional": "opzionale",
        "other companies": "Altre aziende",
        "parent company": "Società madre",
        "permission preset": "Autorizzazioni preimpostate",
        "platform compatibility": {
            "banner text": "Alcuni dei modelli di dispositivo selezionati non sono compatibili con il tipo di attività selezionato. Questo tipo di attività non verrà creato per impostazione predefinita per i modelli di dispositivo incompatibili.",
            "compatible model devices": "Modelli di dispositivi compatibili",
            "count text": "Verrà creato un task per <1>{{compatibleCount}}</1> su {{totalCount}} dispositivi.",
            "create tasks for incompatible devices": "Crea attività per dispositivi incompatibili.",
            "devices from file": "Dispositivi da file",
            "platform": "Piattaforma {{title}}",
            "task applies": "L'attività si applica a",
            "task cannot be created": "Non è possibile creare attività per dispositivi con modelli incompatibili."
        },
        "receiving company": "Questa azienda riceverà i tuoi dispositivi",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Questa operazione richiederà alcuni minuti per essere completata.",
            "banner description": "Per visualizzare lo stato aggiornato delle attività, consultare i dettagli del gruppo di attività o aggiornare la pagina.",
            "description": "Premendo \"Accetta\" verranno riprovate tutte le attività non riuscite. Sei sicuro di voler procedere?",
            "title": "Riprovare tutte le attività del gruppo?"
        },
        "revision": "Revisione",
        "revision value error": "Il valore deve essere a due cifre (00 - 99).",
        "role name": "Nome del ruolo",
        "root company": "Azienda madre",
        "sales email": "Email del responsabile vendite",
        "scheduled time warning": "Le attività con orario programmato non modificano la configurazione dell'ora di connessione FOTA del dispositivo. Le attività verranno eseguite se il dispositivo si connette a FOTA durante la finestra temporale selezionata. Assicurarsi che i dispositivi siano configurati per connettersi a FOTA WEB per un periodo non inferiore alla finestra temporale selezionata.",
        "schedule task": "Pianificazione delle attività",
        "select": "Seleziona",
        "select at least one": {
            "companies": "Selezionare almeno una società",
            "devices": "Selezionare almeno un dispositivo",
            "files": "Selezionare almeno un file",
            "groups": "Selezionare almeno un gruppo",
            "tasks": "Selezionare almeno un'attività",
            "users": "Selezionare almeno un utente"
        },
        "selected": "Selezionato",
        "selected companies": "Aziende selezionate",
        "selected deviceModels": "Modelli selezionati",
        "selected devices": "Dispositivi selezionati",
        "selected files": "File selezionati",
        "selected groups": "Gruppi di dispositivi selezionati",
        "selected productCodes": "Codici prodotto selezionati",
        "selected roles": "Ruoli selezionati",
        "selected tasks": "Attività selezionate",
        "selected users": "Utenti selezionati",
        "select company": "",
        "select group": "",
        "select time interval": "Seleziona l'intervallo di tempo",
        "selected time window": "Intervallo di tempo selezionato: da {{fromDate}} a {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Seleziona i file disponibili per i dispositivi della piattaforma {{platformName}}.",
            "title": "File della piattaforma {{platformName}}"
        },
        "sn": "Numero seriale",
        "specific": "Specifico",
        "time period": "Periodo di tempo",
        "time period custom": "Personalizzato",
        "tls certificate transfer info": "",
        "token has expired": "Il token è scaduto",
        "token is valid": "Il token è valido",
        "transfer companies": "Società di trasferimento",
        "transfer companies description": "Scegliere se trasferire o unire due società. Alcune opzioni sono irreversibili.",
        "transfer devices": "Dispositivi di trasferimento",
        "tri source": {
            "selected tab description": {
                "create task": "L'attività selezionata verrà creata per i dispositivi selezionati utilizzando la casella di controllo.",
                "general": "L'azione selezionata verrà eseguita per i dispositivi scelti utilizzando la casella di controllo."
            },
            "filtered tab description": {
                "create task": "L'attività selezionata verrà creata per i dispositivi filtrati utilizzando uno o più filtri disponibili.",
                "general": "L'azione selezionata verrà eseguita per i dispositivi filtrati utilizzando uno o più filtri disponibili."
            },
            "from file tab description": {
                "create task": "L'attività selezionata verrà creata per i dispositivi specificati nel file caricato.",
                "general": "L'azione selezionata verrà eseguita per i dispositivi specificati nel file caricato."
            }
        },
        "unlocker": {
            "generate unlock key": "Genera chiave di sblocco",
            "generate unlock key description": "Inserisci il \"Codice di blocco\" del dispositivo da TCT nel campo sottostante. Premi il pulsante \"Genera\" per generare una chiave di sblocco e utilizzala in TCT per sbloccare il tuo dispositivo.",
            "invalid lock code": "Codice di blocco dispositivo non valido.",
            "limit reached": "Hai raggiunto il numero massimo di chiavi di sblocco generate.",
            "lock code": "Codice di blocco",
            "unlock key": "Chiave di sblocco",
            "unlock key success message": "Chiave di sblocco generata con successo."
        },
        "upload file": "Carica file",
        "upload file description": "Carica fino a {{count}} file contemporaneamente utilizzando il campo drag-and-drop o selezionandoli.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Le versioni del firmware 04.00.00 e successive includono la protezione dal downgrade. Per maggiori dettagli sulle modifiche al firmware, consultare la nostra documentazione su <1>Teltonika GPS Wiki</1>. Premendo il pulsante \"Avanti\" si accettano e si comprendono le informazioni di cui sopra.",
        "upload firmware unsupported info": "L'aggiornamento a questa versione non è disponibile, contattare l'assistenza Teltonika o il proprio responsabile commerciale Teltonika.",
        "use at least one filter": "Utilizza almeno un filtro",
        "user": "Utente",
        "valid until": "Valido fino al",
        "valid until date disable description": "Questo campo può essere modificato solo quando il periodo di tempo è impostato su \"Personalizzato\"",
        "vehicle model": "Modello"
    },
    "Dropzone": {
        "add file": "Aggiungi file",
        "add files": "Aggiungi file",
        "drop file to upload": "Trascina il file da caricare",
        "drop files to upload": "Trascina i file da caricare",
        "error uploading the file": "Si è verificato un errore durante il caricamento del file",
        "file invalid type": "Tipo di file non valido selezionato.",
        "file successfully uploaded": "File caricato con successo",
        "file syntax": "La sintassi dei file è la seguente:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Il limite massimo di file è stato raggiunto.",
        "only one file can be attached": "È possibile allegare un solo file.",
        "or drop file to upload": "Oppure trascina il file da caricare",
        "or drop files to upload": "Oppure trascina i file da caricare",
        "rows detected": "Righe nel file rilevate con successo",
        "select file": "Seleziona file",
        "select files": "Seleziona i file",
        "select file type": "Selezionare prima il tipo di file.",
        "supported formats": "Formati supportati",
        "too long file name": "Il nome del file è troppo lungo. È consentito un massimo di {{maxLength}} caratteri.",
        "too many files description": "Il resto dei file può essere caricato dopo aver caricato i file selezionati.",
        "too many files title": "È possibile allegare fino a un massimo di {{maxFiles}} file alla volta."
    },
    "Error": {
        "error": "Errore",
        "message wait": "Abbiate pazienza finché non risolviamo l'errore.",
        "title": "Si è verificato un errore!"
    },
    "Feature highlight": {
        "got it": "Capito",
        "new feature": "Nuova funzionalità!",
        "scenarios description": "Ora è possibile impostare uno dei seguenti scenari sul proprio dispositivo: eccesso di velocità, rilevamento di incidenti o rilevamento di traino."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Stato",
        "all permissions": "Tutte le autorizzazioni",
        "batch_id": "ID batch",
        "company_id": "Azienda",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Creato da",
        "current_configuration": "Configurazione",
        "current_firmware": "Firmware",
        "device_imei": "IMEI del dispositivo",
        "file type": "Tipo di file",
        "filtered by": "Filtrato per",
        "filters used": "Filtri utilizzati",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Gruppo",
        "id": "ID",
        "Invalid company": "Azienda non valida",
        "model": "Modello",
        "model_platform": "Piattaforma",
        "Multiple companies": "Aziende multiple",
        "parent company": "Società madre",
        "permission": "Autorizzazione",
        "permission status": "Stato",
        "role": "Ruolo",
        "spec_id": "Spec ID",
        "status_id": "Stato",
        "supported_task_type": "Tipo di attività",
        "table filters": "Filtri tabella",
        "task type": "Tipo di attività",
        "task_queue": "Coda",
        "type": "Tipo",
        "user status": "Stato"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "La dimensione del file firmware ADAS non può essere pari a zero.",
        "ADAS firmware is invalid.": "Il firmware ADAS non è valido.",
        "All notifications were deleted.": "Tutte le notifiche sono state eliminate.",
        "All notifications were marked as read.": "Tutte le notifiche sono state contrassegnate come lette.",
        "At least one user role must be provided.": "È necessario fornire almeno un ruolo utente.",
        "Attributes length is invalid": "La lunghezza degli attributi non è valida.",
        "Banner was updated.": "",
        "Batch was discarded": "Il batch è stato scartato.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "È stato creato un processo di aggiornamento degli attributi in blocco. Gli attributi dei dispositivi saranno aggiornati a breve.",
        "Bulk create job was created. Devices will be created shortly.": "È stata creata un'attività di creazione in blocco. I dispositivi saranno creati a breve.",
        "Bulk create job was created. Tasks will be created shortly.": "È stata creata un'attività di creazione in blocco. Le attività saranno create a breve.",
        "Bulk delete job was created. Companies will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. Le aziende saranno rimosse a breve.",
        "Bulk delete job was created. Devices will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. I dispositivi saranno rimossi a breve.",
        "Bulk delete job was created. Files will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. I file saranno rimossi a breve.",
        "Bulk delete job was created. Groups will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. I gruppi saranno rimossi a breve.",
        "Bulk delete job was created. Product codes will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. I codici prodotto saranno rimossi a breve.",
        "Bulk delete job was created. Users will be removed shortly.": "È stata creata un'operazione di eliminazione in blocco. Gli utenti saranno rimossi a breve.",
        "Bulk task create job was created. Tasks will be created shortly.": "È stata creata un'attività in blocco e le attività appariranno a breve. Le attività sono disponibili nella pagina \"Gruppi di attività\" sotto i dettagli del gruppo di attività.",
        "Bulk update job was created. Devices will be updated shortly.": "È stato creato un processo di aggiornamento in blocco. I dispositivi saranno aggiornati a breve.",
        "Bulk update job was created. Tasks will be updated shortly.": "È stato creato un processo di aggiornamento in blocco. Le attività saranno aggiornate a breve.",
        "Can adapter was added.": "È stato aggiunto un adattatore.",
        "Can adapter was deleted.": "L'adattatore può essere eliminato.",
        "Can adapter was updated.": "L'adattatore è stato aggiornato.",
        "Can chip firmware file size can't be zero": "La dimensione del file del firmware del chip non può essere pari a zero.",
        "Can chip firmware is invalid.": "Il firmware del chip potrebbe non essere valido.",
        "Cannot delete company. Company is not empty.": "Impossibile eliminare l'azienda. L'azienda non è vuota.",
        "Cannot delete file. It is used by pending or running tasks.": "Impossibile eliminare il file. Viene utilizzato per attività in sospeso o in esecuzione.",
        "Cannot delete file. It is used by running tasks.": "Impossibile eliminare il file. È utilizzato dall'esecuzione di attività.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Non è possibile eliminare il codice prodotto assegnato ai dispositivi.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Limite di aziende superato.",
        "Companies in the request must belong to the selected root.": "Le aziende nella richiesta devono appartenere alla radice selezionata.",
        "Company merge job was created. It will be merged shortly.": "È stata creata un'operazione di fusione aziendale. La fusione avverrà a breve.",
        "Company name already exist.": "Il nome dell'azienda esiste già.",
        "Company level change is not allowed.": "Non è consentito modificare il livello aziendale.",
        "Company level successfully changed": "Livello aziendale modificato con successo.",
        "company level successfully reverted": "Il livello aziendale è stato ripristinato con successo al livello assegnato automaticamente.",
        "Company not allowed to be merged": "Azienda non autorizzata alla fusione.",
        "company resource limits changed": "Limiti delle risorse aziendali modificati con successo.",
        "Company was created.": "L'azienda è stata creata.",
        "Company was deleted.": "L'azienda è stata cancellata.",
        "Company was updated.": "L'azienda è stata aggiornata.",
        "compatibilities added": "{{count}} nuove compatibilità aggiunte durante la sincronizzazione.",
        "compatibilities synchronized": "Compatibilità mancanti sincronizzate con successo.",
        "Configuration cannot have FOTA functionality disabled": "La configurazione non può avere la funzionalità FOTA disabilitata.",
        "Configuration file cannot contain duplicate parameters": "Il file di configurazione non può contenere parametri duplicati.",
        "Configuration file size can't be zero": "La dimensione del file di configurazione non può essere zero.",
        "Configuration files count limit exceeded.": "Limite di conteggio dei file di configurazione superato.",
        "Configuration version must be defined": "È necessario definire la versione di configurazione.",
        "custom resource limits successfully reverted": "I limiti delle risorse personalizzate sono stati ripristinati con successo ai limiti assegnati automaticamente.",
        "Custom roles feature is not enabled.": "La funzione dei ruoli personalizzati può essere utilizzata solo dagli utenti con livello aziendale Premium. I ruoli personalizzati creati in precedenza possono essere eliminati.",
        "desktop license added": "La licenza desktop \"{{name}}\" è stata aggiunta con successo.",
        "Devices already are in target company": "I dispositivi sono già presenti nell'azienda target.",
        "Device already exists.": "Il dispositivo esiste già.",
        "Device bulk attribute update file cannot be empty": "Il file di aggiornamento degli attributi di massa dei dispositivi non può essere vuoto.",
        "Device bulk attribute update file should be .csv": "Il file di aggiornamento degli attributi di massa dei dispositivi deve essere in formato .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Limite di esportazione dei dispositivi raggiunto. Non è possibile esportare più di 100.000 dispositivi.",
        "Device import limit reached. You can not import more than 100 devices": "Limite di importazione dei dispositivi raggiunto. Non è possibile importare più di 100 dispositivi.",
        "Device model and task type compatibility was updated.": "È stata aggiornata la compatibilità tra modelli di dispositivi e tipi di attività.",
        "Device model was created.": "È stato creato il modello del dispositivo.",
        "Device model was deleted.": "Il modello del dispositivo è stato eliminato.",
        "Device model was updated.": "Il modello del dispositivo è stato aggiornato.",
        "Device not found": "Dispositivo non trovato.",
        "Device Transfer job was created. Devices will be transfered shortly.": "È stato creato un processo di trasferimento dei dispositivi. I dispositivi saranno trasferiti a breve.",
        "Device was added.": "Dispositivo aggiunto.",
        "Device was deleted.": "Il dispositivo è stato eliminato.",
        "Device was updated.": "Il dispositivo è stato aggiornato.",
        "Email or password is incorrect.": "L'indirizzo e-mail o la password inseriti non sono corretti.",
        "Failed to create Product code": "Impossibile creare il codice prodotto.",
        "Failed to delete Product code": "Impossibile eliminare il codice prodotto.",
        "Failed to import devices.": "Impossibile importare i dispositivi.",
        "Failed to Read Product code": "Impossibile leggere il codice del prodotto.",
        "Failed to retry failed tasks": "Impossibile riprovare le attività non riuscite.",
        "Failed to update Product code": "Impossibile aggiornare il codice del prodotto.",
        "Failed to update task for retry": "Impossibile riprovare l'operazione non riuscita.",
        "Field is not valid": "Il campo non è valido.",
        "File description is too long. Max 255 characters allowed.": "La descrizione del file è troppo lunga. È consentito un massimo di 255 caratteri.",
        "File exceeds entries limit of 10000.": "Il file supera il limite di 10.000 voci.",
        "File must not contain duplicated IMEIs": "Il file non deve contenere IMEI duplicati.",
        "File must not contain IMEIs that already exist in database.": "Il file non deve contenere IMEI già presenti nel database.",
        "File must not contain invalid IMEIs": "Il file non deve contenere IMEI non validi.",
        "File name is too long. Max 255 characters allowed.": "Il nome del file è troppo lungo. Sono consentiti al massimo 255 caratteri.",
        "File name should not contain illegal characters or symbols": "Il nome del file non può contenere caratteri speciali.",
        "File not found": "File non trovato.",
        "File was deleted.": "Il file è stato eliminato.",
        "File was successfully uploaded.": "Il file è stato caricato con successo.",
        "File was updated.": "Il file è stato aggiornato.",
        "File was uploaded. Devices will be imported shortly.": "Il file è stato caricato. I dispositivi saranno importati a breve.",
        "File will be created shortly. Check files in a second.": "Il file verrà creato a breve. Controlla i file tra un secondo.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "La dimensione del file del firmware non può essere zero.",
        "First device in file not found.": "Primo dispositivo nel file non trovato.",
        "Forbidden": "Proibito.",
        "Group name already exist.": "Il nome del gruppo esiste già.",
        "Group was added.": "\"{{group}}\" creato con successo.",
        "Group was created.": "È stato creato un gruppo.",
        "Group was deleted.": "Il gruppo è stato eliminato.",
        "Group was updated.": "Il gruppo è stato aggiornato.",
        "Invalid device bulk update attribute": "Attributo di aggiornamento in blocco del dispositivo non valido.",
        "Invalid email address.": "Indirizzo e-mail non valido.",
        "Invalid file contents": "Contenuto del file non valido.",
        "Invalid file name": "Nome file non valido.",
        "Invalid invitation token.": "Token di invito non valido.",
        "Invalid token": "Token non valido.",
        "Invalid token length": "Lunghezza token non valida.",
        "Internal Server Error": "Errore interno del server.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "La licenza è stata cancellata.",
        "License was updated.": "La licenza è stata aggiornata.",
        "Maximum companies hierarchy depth exceeded": "Profondità massima della gerarchia aziendale superata",
        "Maximum device group size exceeded.": "Dimensione massima del gruppo di dispositivi superata.",
        "Method Not Allowed": "Metodo non consentito.",
        "Network Error": "Errore di rete.",
        "No changes made": "Non sono state apportate modifiche.",
        "No resources found.": "Nessuna risorsa trovata.",
        "not allowed to affect batch": {
            "description": "Assicurati di controllare l'azienda dell'utente che ha creato questo gruppo di attività.",
            "title": {
                "approve": "Non hai l'autorizzazione per approvare questo batch.",
                "discard": "Non hai il permesso di eliminare questo batch."
            }
        },
        "Not Found": "Non trovato.",
        "Notification was deleted.": "La notifica è stata eliminata.",
        "notify when done title": "L'operazione potrebbe richiedere alcuni minuti. Premi il pulsante sottostante per chiudere questa schermata e riceverai una notifica al termine dell'operazione.",
        "Obd record was created.": "È stato creato un record OBD.",
        "Obd record was updated.": "Il record OBD è stato aggiornato.",
        "offline license added": "La licenza offline \"{{name}}\" è stata aggiunta con successo.",
        "Offline license was deleted.": "La licenza offline è stata eliminata.",
        "Only id_list source is supported.": "È supportata solo la fonte id_list.",
        "Only users with Teltonika email can be invited into internal companies.": "Solo gli utenti con un indirizzo e-mail Teltonika possono essere invitati nelle aziende interne.",
        "Only users with Teltonika email can be moved into internal companies.": "Solo gli utenti con un indirizzo e-mail Teltonika possono essere trasferiti nelle aziende interne.",
        "Parent company cannot be a descendant of the updated company.": "La società madre non può essere una discendente della società aggiornata.",
        "Password reset link was sent to Your email.": "Il link per reimpostare la password è stato inviato alla tua email.",
        "Password reset token is invalid, expired or related user no longer exists.": "Il token di reimpostazione della password non è valido, è scaduto o l'utente non esiste più.",
        "Password was changed.": "La password è stata modificata.",
        "product code added": "Il codice prodotto \"{{code}}\" è stato aggiunto con successo.",
        "Product code is too long. Max 200 characters allowed.": "Il codice prodotto è troppo lungo. Sono consentiti al massimo 200 caratteri.",
        "ProductCode already exists.": "Il codice prodotto esiste già.",
        "ProductCode not found": "Codice prodotto non trovato.",
        "Product code was deleted.": "Il codice prodotto è stato eliminato.",
        "Product code was updated.": "Il codice del prodotto è stato aggiornato.",
        "Retry failed tasks job was created": "È stato creato un processo di riprova delle attività non riuscite.",
        "Role cannot be set for an internal user.": "Non è possibile impostare un ruolo per un utente interno.",
        "Role was created.": "Il ruolo è stato creato.",
        "Role was deleted.": "Il ruolo è stato eliminato.",
        "Role was updated.": "Il ruolo è stato aggiornato.",
        "selected company changed": "L'azienda selezionata è stata modificata.",
        "Selected firmware bundle is not supported by the device.": "Il pacchetto firmware selezionato non è supportato dal dispositivo.",
        "Server Error": "Errore del server.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "È stato inviato un SMS.",
        "Something went wrong while saving a new password.": "Si è verificato un errore durante il salvataggio di una nuova password.",
        "Successfully logged out.": "Disconnessione riuscita.",
        "System Admin user level is required in order to perform this action.": "Per eseguire questa azione è necessario il livello utente Amministratore di sistema.",
        "Target company cannot be a descendant of source company.": "L'azienda di destinazione non può essere un'azienda discendente dell'azienda di origine.",
        "Task create limit exceeded.": "Non è possibile creare un gruppo di attività per più di 100.000 dispositivi.",
        "Task type is not retriable": "Il tipo di attività non è ripetibile",
        "Task was added.": "È stata aggiunta un'attività.",
        "task was created": "L'attività è stata creata per {{imei}} (\"{{taskType}}\"). L'attività è disponibile nella pagina \"Dispositivi\" sotto \"Attività\" nei dettagli del dispositivo.",
        "Task was updated.": "L'attività è stata aggiornata.",
        "Tasks were approved": "Le attività sono state approvate.",
        "The given data was invalid.": "I dati forniti non erano validi.",
        "time zone changed": "Il fuso orario è stato modificato.",
        "Token cannot be null or empty": "Il token non può essere nullo o vuoto.",
        "token created": "Il token API è stato creato con successo.",
        "Token has expired": "Il token è scaduto.",
        "Token's and token's owner companies do not match": "I token e le società proprietarie dei token non corrispondono.",
        "Token was deleted.": "Il token è stato eliminato.",
        "Too many resources in the request": "Troppe risorse nella richiesta",
        "Too Many Requests": "Troppe richieste.",
        "Transfer token created": "Token di trasferimento creato.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "L'autenticazione a due fattori è già attivata per l'utente.",
        "Two factor authentication successfully disabled.": "Autenticazione a due fattori disabilitata con successo.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Impossibile inviare SMS. A questo dispositivo non è stato assegnato un numero GSM.",
        "Unable to validate Your request.": "Impossibile convalidare la tua richiesta.",
        "Unauthenticated.": "Non autenticato.",
        "Unauthorized": "Non autorizzato.",
        "User access level is not valid": "Il livello di accesso dell'utente non è valido",
        "User invitation was revoked": "Invito cancellato con successo.",
        "User invitation was re-sent": "L'invito all'utente è stato inviato nuovamente.",
        "User is already in the system.": "L'utente è già presente nel sistema.",
        "User was created.": "Utente creato.",
        "User was deleted.": "Utente eliminato.",
        "User was invited.": "Invito utente inviato con successo.",
        "User was updated": "L'utente è stato aggiornato.",
        "Users count limit exceeded.": "Limite di utenti superato.",
        "Your password has been changed.": "La tua password è stata modificata."
    },
    "General": {
        "0": "Utente",
        "5": "Assistenza",
        "10": "Amministratore",
        "15": "Admin Manager",
        "19": "",
        "20": "Utente del sistema",
        "99": "Super utente",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Creazione dell'azienda",
        "Company.Delete": "Eliminazione dell'azienda",
        "Company.Merge": "Fusione aziendale",
        "Company.Update": "Aggiornamento aziendale",
        "Device.Export": "Esportazione dei dispositivi",
        "Device.Read": "Lettura dei dispositivi",
        "Device.SecretsRead": "",
        "Device.Transfer": "Trasferimento dei dispositivi",
        "Device.Unlock": "Sblocco dei dispositivi",
        "Device.Update": "Aggiornamento dei dispositivi",
        "DeviceGroup.Create": "Creazione di gruppi di dispositivi",
        "DeviceGroup.Delete": "Eliminazione di gruppi di dispositivi",
        "DeviceGroup.Read": "Lettura gruppo dispositivi",
        "DeviceGroup.Update": "Aggiornamento dei gruppi di dispositivi",
        "File.Create": "Creazione di file",
        "File.Delete": "Eliminazione dei file",
        "File.Download": "Download di file",
        "File.Read": "Lettura dei file",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Aggiornamento dei file",
        "Role.Create": "Creazione di ruoli",
        "Role.Delete": "Eliminazione dei ruoli",
        "Role.Read": "Ruolo di lettura",
        "Role.Update": "Aggiornamento dei ruoli",
        "Task.Create": "Creazione di attività",
        "Task.Read": "Lettura dei compiti",
        "Task.Retry": "Ripetizione dei compiti",
        "Task.Update": "Aggiornamento delle attività",
        "TaskGroup.Read": "Lettura del gruppo di attività",
        "TctIntegration.Access": "Integrazione TCT",
        "Token.Create": "Creazione di token",
        "Token.Delete": "Eliminazione token",
        "Token.Read": "Lettura token",
        "User.Create": "",
        "User.Delete": "Eliminazione utente",
        "User.Read": "Lettura utente",
        "User.Update": "Aggiornamento utente",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Elenco delle autorizzazioni 1-Wire",
        "1_wire_authorization_list": "Elenco delle autorizzazioni 1-Wire",
        "Active": "Attivo",
        "adas_firmware": "Firmware ADAS",
        "apx_firmware": "Firmware APX",
        "assign can package": "Assegna pacchetto CAN",
        "assigned package": "Pacchetto assegnato",
        "automatic": "Automatico",
        "banner management": "",
        "batches": "Gruppi di attività",
        "black_box": "Scatola nera",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Elenco delle autorizzazioni Bluetooth",
        "bluetooth_authorization_list": "Elenco delle autorizzazioni Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Incompatibile",
                "true": "Compatibile"
            },
            "web_editor_support": {
                "false": "TCT web non supportato",
                "true": "Supportato dal TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Nome dell'adattatore CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Configurazione OEM",
        "can_debug_log": "Log di debug CAN",
        "can oem file package": "Pacchetto file OEM",
        "can oem file vehicle": "File OEM veicolo",
        "can package": "Pacchetto OEM",
        "can program number": "Numero programma CAN",
        "can revision": "Revisione CAN",
        "can software date": "Data software CAN",
        "can type": "Tipo CAN",
        "Cancelled": "Annullato",
        "cancel task": "Annulla attività",
        "can_chip_firmware": "Firmware del chip FM CAN",
        "carrier_advance_firmware": "Firmware Carrier Advance",
        "carrier_advance_settings": "Impostazioni Carrier Advance",
        "carrier_apx_firmware": "Firmware Carrier APX",
        "carrier_apx_settings": "Impostazioni Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "File del registratore di temperatura del Carrier",
        "certificate": "Certificato",
        "click for more details": "Clicca per maggiori dettagli",
        "client ip": "IP del cliente",
        "clone model": "Clonazione del modello del dispositivo",
        "collapse menu": "Chiudi menu",
        "companies": "Aziende",
        "company": "Azienda",
        "company level": "Livello aziendale",
        "company type": "Tipo di azienda",
        "company name": "Nome dell'azienda",
        "Completed": "Completato",
        "Completed with errors": "Completato con errori",
        "configuration": "Configurazione",
        "configuration_36": "Configurazione (FM36)",
        "configuration_64": "Configurazione (FMB64)",
        "crash_dump": "Registro dei crash dump",
        "created at": "Creato il",
        "created by": "Creato da",
        "custom": "Personalizzato",
        "custom resource limits": "Limiti delle risorse personalizzati",
        "dashboard": "Dashboard",
        "delete desktop license": "Elimina licenza desktop",
        "delete offline license": "Elimina licenza offline",
        "desktopLicenses": "Licenze desktop",
        "device_export_file_csv": "File di esportazione dei dispositivi (.csv)",
        "device_export_file_xlsx": "File di esportazione dei dispositivi (.xlsx)",
        "deviceModels": "Modelli",
        "deviceModelTaskCompatibilities": "Compatibilità",
        "device_transfer_report": "Rapporto sul trasferimento dei dispositivi",
        "device group": "Gruppo",
        "DeviceImportFile": "File di importazione dei dispositivi",
        "devices": "Dispositivi",
        "download file": "Scarica file",
        "download offline license": "Scarica la licenza offline",
        "dsm_firmware": "Firmware DSM",
        "dtb": "DTB",
        "edit compatibility": "Modifica compatibilità dei dispositivi",
        "edit model": "Modifica modello dispositivo",
        "edit company": "Modifica azienda",
        "edit desktop license": "Modifica licenza desktop",
        "edit device": "Modifica dispositivo",
        "edit file": "Modifica file",
        "edit group": "Modifica gruppo",
        "edit in tct web": "Modifica nel TCT web",
        "edit in tct web disabled": "La modifica nel TCT web è disponibile solo per il livello aziendale Premium.",
        "edit product code": "Modifica codice prodotto",
        "edit role": "Modifica ruolo",
        "edit smart group": "Modifica gruppo intelligente",
        "edit user": "Modifica utente",
        "Empty": "Vuoto",
        "enter here": "Entra qui",
        "exception_info": "Informazioni sulle eccezioni",
        "Executing": "Esecuzione",
        "expand menu": "Espandi menu",
        "Expired": "Scaduto",
        "Factory": "",
        "Failed": "Non riuscito",
        "file": "File",
        "file data": "Dati dei file",
        "files": "File",
        "file deleted": "Il file è stato eliminato",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Pacchetto firmware",
        "fw_bundle_ble": "Pacchetto - Firmware BLE",
        "fw_bundle_ble_dtb": "Pacchetto - BLE DTB",
        "fw_bundle_can": "Pacchetto - Firmware CAN",
        "fw_bundle_can_dtb": "Pacchetto - CAN DTB",
        "fw_bundle_dtb": "Pacchetto - DTB principale",
        "fw_bundle_mainfw": "Pacchetto - Firmware principale",
        "generic": "",
        "global_configuration": "Configurazione globale",
        "global_firmware": "Firmware globale",
        "gnssm_download_assistant": "Assistente di download GNSS-M",
        "gnssm_firmware": "Firmware GNSS-M",
        "group": "Gruppo",
        "groups": "Gruppi di dispositivi",
        "hardware key": "Chiave hardware",
        "id": "ID",
        "id_collection_file": "File di raccolta ID",
        "imei restriction": "Restrizione IMEI",
        "Inactive": "Inattivo",
        "Invalid": "Non valido",
        "invalid model": "Modello non valido",
        "invalid model_name": "Modello non valido",
        "InvitationExpired": "Invito scaduto",
        "InvitationPending": "Invito in sospeso",
        "Legacy": "Legacy",
        "legacy model": "Modello legacy",
        "legacy model_platform": "Piattaforma legacy",
        "legacy platform": "Piattaforma legacy",
        "license has expired": "La licenza è scaduta",
        "loading": "Caricamento in corso",
        "log": "Registro",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Manuale",
        "ManualGeofenceList": "",
        "manual geofence list": "Elenco manuale degli scenari di geofence",
        "manual_geofence_list": "Elenco manuale degli scenari di geofence",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Firmware del modem MeiG",
        "menu": "Menu",
        "modem version": "Versione modem",
        "netprisma_modem_firmware": "Firmware del modem NETPRISMA",
        "nmea_log": "Registro NMEA",
        "no": "No",
        "no results": "Nessun risultato iniziale trovato",
        "no results description": "Non appena {{name}} viene caricato su FOTA WEB, potrai visualizzare i dati qui",
        "not assigned": "Non assegnato",
        "not assigned configuration_file_id": "Configurazione non assegnata",
        "not assigned current_configuration": "Configurazione non assegnata",
        "not assigned current_firmware": "Firmware non assegnato",
        "not assigned firmware_file_id": "Firmware non assegnato",
        "not assigned group_id": "Gruppo non assegnato",
        "not assigned model": "Modello non assegnato",
        "not assigned spec_id": "Spec ID non assegnato",
        "not assigned task_type": "Tipo di attività non assegnato",
        "obd_chip_firmware": "Firmware del chip FM OBD",
        "obd chip firmware version": "Versione firmware chip OBD",
        "Offline": "Offline",
        "offline licenses": "Licenze offline",
        "Online": "Online",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "oppure",
        "other": "Altro",
        "Pending": "In attesa di approvazione",
        "Pending approval": "In attesa di approvazione",
        "permission disabled": "Disabilitato",
        "permission enabled": "Abilitato",
        "productCodes": "Codici prodotto",
        "psub": "File di abbonamento",
        "quectel_fw": "Firmware del modem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware del modem Quectel",
        "resend invite": "Invia nuovamente l'invito",
        "restricted": "Limitato",
        "retry": "Riprova",
        "roles": "Ruoli e autorizzazioni",
        "Running": "In esecuzione",
        "RxAutoscan": "Ricezione file CAN con scansione automatica",
        "RxBlackBox": "Ricezione della scatola nera",
        "RxBluetoothAuthorizationList": "Ricezione dell'elenco delle autorizzazioni Bluetooth",
        "RxCanDebugLog": "Ricezione del log di debug CAN",
        "RxCarrierExtractions": "Scarica le Carrier extractions",
        "RxCarrierLoggerFiles": "Scarica i file del registratore di temperatura del Carrier",
        "RxConfiguration": "Ricezione della configurazione",
        "RxCrashDump": "Ricezione del log del crash dump",
        "RxExceptionInfo": "Ricezione di informazioni sulle eccezioni",
        "RxLog": "Ricezione del log interno",
        "RxManualGeofenceList": "Ricezione dell'elenco degli scenari di geofence manuali",
        "RxNmeaLog": "Ricezione del log NMEA",
        "RxOneWireAuthorizationList": "Ricevi l'elenco delle autorizzazioni 1-Wire",
        "RxWdLog": "Ricezione del log watch-dog (WD)",
        "select company": "Seleziona azienda",
        "SetBindSim": "Collega il dispositivo con le schede SIM attuali",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Disattiva funzione",
        "SetEnableFeature": "Abilita funzione",
        "SetForceLockSim": "Blocco forzato della SIM",
        "SetUnbindSim": "Scollegare il dispositivo dalla scheda SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Stato",
        "task details": "Dettagli dell'attività",
        "task groups": "Gruppi di attività",
        "tasks": "Gruppi di attività",
        "tasksCompatibility": "Compatibilità delle attività",
        "task type": "Tipo di attività",
        "Tct": "",
        "time zone": "Fuso orario",
        "total": "Totale",
        "tutorials": "Tutorial",
        "TxAdasFirmware": "Caricamento del firmware ADAS",
        "TxAgpsMt3333": "Trasferimento file AGPSM",
        "TxAgpsQuectelL89": "Trasferimento file AGPSQ",
        "TxAutoscanCanConfiguration": "Carica file OEM con scansione automatica",
        "TxBleFirmware": "Caricamento firmware BLE",
        "TxBlueNrgFirmware": "Carica il firmware BlueNrg",
        "TxBluetoothAuthorizationList": "Carica l'elenco delle autorizzazioni Bluetooth",
        "TxBundleBle": "Caricamento firmware BLE",
        "TxBundleBleDtb": "Caricamento BLE DTB",
        "TxBundleCan": "Caricamento firmware CAN",
        "TxBundleCanDtb": "Caricamento CAN DTB",
        "TxBundleDtb": "Carica DTB principale",
        "TxBundleFirmware": "Caricamento firmware principale",
        "TxCanAdapterModeChange": "Modifica della modalità dell'adattatore CAN esterno",
        "TxCanAdapterModeChangeInternal": "Modifica della modalità dell'adattatore CAN interno",
        "TxCanAdapterUpdate": "Caricamento del firmware dell'adattatore CAN",
        "TxCanAdapterUpdateInternal": "Aggiornamento dell'adattatore CAN interno",
        "TxCanChipFirmware": "Carica il firmware del chip CAN FMXY50",
        "TxCanConfiguration": "Carica file OEM",
        "TxCarrierAdvanceFirmware": "Aggiornamento del firmware Carrier Advance",
        "TxCarrierAdvanceSettings": "Aggiornamento delle impostazioni Carrier Advance",
        "TxCarrierApxFirmware": "Aggiornamento del firmware Carrier APX",
        "TxCarrierApxSettings": "Aggiornamento delle impostazioni Carrier APX",
        "TxConfiguration": "Configurazione del caricamento",
        "TxDsmFirmware": "Carica firmware DSM",
        "TxDtb": "Carica DTB",
        "TxFirmware": "Caricamento del firmware",
        "TxFirmwareBundle": "Carica pacchetto firmware container",
        "TxFirmwareBundleParts": "Carica pacchetto firmware",
        "TxFotaCertificate": "Aggiornamento certificato FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Carica GNSS-M Download Assistant",
        "TxGNSSMFirmware": "Caricamento del firmware GNSS-M",
        "TxManualGeofenceList": "Carica elenco scenari geofence manuali",
        "TxMeigModemDeltaFirmware": "Carica il firmware del modem MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Carica il firmware del modem NETPRISMA Delta",
        "TxObdChipFirmware": "Aggiornamento chip OBD",
        "TxObdConfig": "Trasferimento del file di configurazione OBD",
        "TxOneWireAuthorizationList": "Carica l'elenco delle autorizzazioni 1-Wire",
        "TxPSub": "Trasferisci file di abbonamento",
        "TxQuectelModemDeltaFirmware": "Carica il firmware del modem Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Carica certificato TLS utente",
        "users": "Utenti",
        "Unknown": "Sconosciuto",
        "unknown": "Sconosciuto",
        "unknown model_platform": "Piattaforma sconosciuta",
        "unknown origin": "",
        "unknown platform": "Piattaforma sconosciuta",
        "unrestricted": "Senza restrizioni",
        "Verifying": "Verifica",
        "vin": "VIN",
        "vip status": "Stato VIP",
        "wd_log": "Registro WD",
        "yes": "Sì"
    },
    "Maintenance": {
        "title": "Attendi! Siamo in fase di manutenzione."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} non riuscito a causa di un errore del server.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di annullare tutte le attività selezionate. Alcune attività sono associate a risorse di aziende diverse.",
            "Cancel tasks action failed. No resources found.": "Nessuna attività corrisponde alla tua selezione. Controlla la tua selezione e riprova.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "La società \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) è stata incorporata in \"{{TargetCompanyName}}\" ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "La fusione delle società non è riuscita. Le società \"{{SourceCompanyId}}\" e \"{{TargetCompanyId}}\" non possono essere fuse a causa di impostazioni o autorizzazioni incompatibili.",
            "Create device group tasks action failed. No resources found.": "Impossibile creare attività per Smart Group. Prova a riassegnare il file.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} attività create per il gruppo di dispositivi ID:{{GroupId}} dispositivi.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di creare attività per tutti i dispositivi selezionati. Alcuni dispositivi appartengono ad aziende diverse.",
            "Create tasks action failed. No resources found.": "Nessun dispositivo corrisponde alla tua selezione. Controlla la selezione dei dispositivi e riprova.",
            "Create tasks action failed. No resources processed.": "Impossibile elaborare i dispositivi selezionati. Riprovare a creare il gruppo di attività.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di eliminare tutte le aziende selezionate. Alcune aziende non sono sotto la tua diretta gestione.",
            "Delete companies action failed. No resources found.": "Nessuna azienda corrisponde alla tua selezione. Controlla la selezione delle aziende e riprova.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di eliminare tutti i file selezionati. Alcuni file sono associati a risorse di aziende diverse.",
            "Delete files action failed. No resources found.": "Nessun file corrisponde alla tua selezione. Controlla la selezione dei file e riprova.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di eliminare tutti i gruppi di dispositivi selezionati. Alcuni gruppi di dispositivi contengono risorse di aziende diverse.",
            "Delete groups action failed. No resources found.": "Nessun gruppo di dispositivi corrisponde alla tua selezione. Controlla la selezione del gruppo di dispositivi e riprova.",
            "Delete product codes action failed. No resources found.": "Nessun codice prodotto corrisponde alla tua selezione. Controlla la selezione del codice prodotto e riprova.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Non hai il permesso di eliminare tutti gli utenti selezionati. Alcuni utenti appartengono a società diverse.",
            "Delete users action failed. No resources found.": "Nessun utente corrisponde alla tua selezione. Controlla la tua selezione di utenti e riprova.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} dispositivi esportati in \"{{Filename}}\".",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} dispositivi importati.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} dispositivi elaborati, {{TasksCreatedCount}} attività create.",
            "Export devices action failed. No resources found.": "Nessun dispositivo corrisponde alla tua selezione. Controlla la selezione dei dispositivi e riprova.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} attività sono state riportate in sospeso nel gruppo di attività {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Ambito di richiesta non valido. Le risorse devono appartenere a un'unica radice.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} aziende eliminate.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} gruppi di dispositivi eliminati.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} attributi del dispositivo aggiornati.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} modelli di dispositivi eliminati.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} dispositivi aggiornati.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} file eliminati.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} codici prodotto eliminati.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} attività annullate.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} attività aggiornate.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} utente/i eliminato/i.",
            "Retry tasks action failed. No resources found.": "Nessuna attività corrisponde alla tua selezione. Controlla la tua selezione e riprova.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Non disponi dell'autorizzazione per trasferire tutti i dispositivi selezionati. Alcuni dispositivi appartengono ad aziende diverse.",
            "Transfer devices action failed. No resources found.": "Nessun dispositivo corrisponde alla tua selezione. Controlla la selezione dei dispositivi e riprova.",
            "Transfer devices action failed. No resources processed.": "Impossibile elaborare i dispositivi selezionati. Riprovare a trasferire i dispositivi.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} di {{TotalDevicesToTransfer}} dispositivi trasferiti.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Non disponi dell'autorizzazione per aggiornare tutti i dispositivi selezionati. Alcuni dispositivi appartengono ad aziende diverse.",
            "Update devices action failed. No resources found.": "Nessun dispositivo corrisponde alla tua selezione. Controlla la selezione dei dispositivi e riprova.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Non disponi dell'autorizzazione per aggiornare gli attributi di tutti i dispositivi selezionati. Alcuni dispositivi appartengono ad aziende diverse.",
            "Update devices attributes action failed. No resources found.": "Nessun dispositivo corrisponde alla tua selezione. Controlla la selezione dei dispositivi e riprova.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Non disponi dell'autorizzazione per aggiornare tutte le attività selezionate. Alcune attività sono associate a risorse di aziende diverse.",
            "Update tasks action failed. No resources found.": "Nessuna attività corrisponde alla tua selezione. Controlla la tua selezione e riprova.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Nessuna notifica",
        "notifications": "Notifiche",
        "notifications will be listed": "Tutte le nuove notifiche saranno elencate qui",
        "remove notification": "Rimuovi notifica",
        "see previous notifications": "Vedi notifiche precedenti",
        "timestamps": {
            "days ago": "{{days}} giorni fa",
            "hours ago": "{{hours}}h fa",
            "minutes ago": "{{minutes}} min fa",
            "moments ago": "Pochi istanti fa"
        },
        "title": {
            "BackgroundActionFailed": "Azione non riuscita",
            "CompaniesSuccessfullyDeleted": "Aziende eliminate con successo",
            "CompanyBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione delle aziende",
            "CompanyLevelChanged": "Livello aziendale modificato",
            "CompanyLevelDowngradeReminder": "Prossimo downgrade livello aziendale",
            "CompanyMergeFailed": "Si è verificato un errore durante l'unione delle aziende",
            "CompanySuccessfullyMerged": "Aziende fuse con successo",
            "DeviceAttributesSuccessfullyUpdated": "Attributi del dispositivo aggiornati con successo",
            "DeviceBulkAttributeUpdateFailed": "Si è verificato un errore durante l'aggiornamento degli attributi del dispositivo",
            "DeviceBulkUpdateFailed": "Si è verificato un errore durante l'aggiornamento dei dispositivi",
            "DeviceExportFailed": "Si è verificato un errore durante l'esportazione dei dispositivi",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Gruppi di dispositivi eliminati con successo",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Si è verificato un errore durante la creazione delle attività del gruppo intelligente",
            "DeviceGroupTasksSuccessfullyCreated": "Attività Smart Group create con successo",
            "DeviceModelBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione dei modelli di dispositivo",
            "DeviceModelsSuccessfullyDeleted": "Modelli di dispositivi eliminati con successo",
            "DevicesSuccessfullyTransferred": "Dispositivi trasferiti con successo",
            "DevicesSuccessfullyUpdated": "Dispositivi aggiornati con successo",
            "DeviceTransferFailed": "Si è verificato un errore durante il trasferimento dei dispositivi",
            "ExportFailed": "Esportazione delle risorse non riuscita",
            "ExportSucceeded": "Dispositivi esportati con successo",
            "FailedTasksRetryFailed": "Si è verificato un errore durante il riprovare le attività",
            "FailedTasksSuccessfullyRetried": "Attività riproposte con successo",
            "FileBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione dei file",
            "FilesSuccessfullyDeleted": "File eliminati con successo",
            "GroupBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione dei gruppi di dispositivi",
            "ImportFailed": "Importazione delle risorse non riuscita",
            "ImportSucceeded": "Dispositivi importati con successo",
            "ProductCodeBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione dei codici prodotto",
            "ProductCodesSuccessfullyDeleted": "Codici prodotto eliminati con successo",
            "ResourceUpdateFailed": "Aggiornamento delle risorse non riuscito",
            "ResourceUpdateSucceeded": "Aggiornamento delle risorse riuscito",
            "RoleBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione dei ruoli",
            "RolesSuccessfullyDeleted": "Ruoli eliminati con successo",
            "TaskBulkCancelFailed": "Si è verificato un errore durante l'annullamento delle attività",
            "TaskBulkCreateFailed": "Si è verificato un errore durante la creazione di un gruppo di attività",
            "TaskBulkUpdateFailed": "Si è verificato un errore durante l'aggiornamento delle attività",
            "TaskGroupSuccessfullyCreated": "Gruppo di attività creato con successo",
            "TasksPropagationFailed": "Operazione di propagazione delle attività non riuscita",
            "TasksPropagationSucceeded": "Operazione di propagazione dei task completata con successo",
            "TasksPropagationWarning": "Il processo di propagazione delle attività è terminato con avvisi",
            "TasksSuccessfullyCanceled": "Attività annullate con successo",
            "TasksSuccessfullyUpdated": "Attività aggiornate con successo",
            "UserBulkDeleteFailed": "Si è verificato un errore durante l'eliminazione degli utenti",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Utenti eliminati con successo"
        }
    },
    "Permission actions": {
        "Access": "Integrazione TCT",
        "Create": "Crea",
        "Delete": "Elimina",
        "Download": "Scarica",
        "Export": "Esporta",
        "Merge": "Unisci",
        "Read": "Leggi",
        "Retry": "Riprova",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Trasferimento",
        "Unlock": "Sblocca",
        "Update": "Aggiornamento"
    },
    "Permission groups": {
        "company": "Aziende",
        "device": "Dispositivi",
        "device group": "Gruppi di dispositivi",
        "file": "File",
        "role": "Ruoli",
        "task": "Attività",
        "task group": "Gruppi di attività",
        "token": "Token",
        "user": "Utenti"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Questa opzione è disabilitata per gli utenti con livello aziendale Basic.",
                "token list": "I token di integrazione API sono disabilitati per gli utenti con livello aziendale Basic."
            },
            "custom_role_support": {
                "create role": "Questa funzione può essere utilizzata solo dagli utenti con livello aziendale Premium.",
                "edit role": "Questa funzione può essere utilizzata solo dagli utenti con livello aziendale Premium. I ruoli personalizzati creati in precedenza possono essere eliminati.",
                "edit user": "Questa funzione può essere utilizzata solo dagli utenti con livello aziendale Premium. I ruoli personalizzati assegnati in precedenza possono essere rimossi."
            },
            "task_schedule_support": {
                "table head": "Questa funzione può essere utilizzata solo dagli utenti con livelli aziendali Standard e Premium. Le attività aggiunte in precedenza con pianificazioni continueranno a essere eseguite."
            }
        },
        "general message": "Questa funzione può essere utilizzata solo dagli utenti con livelli aziendali Standard e Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Non è possibile creare attività per più di {{limitCount}} dispositivi contemporaneamente."
        }
    },
    "Search": {
        "code": "Codice",
        "description": "Descrizione",
        "email": "E-mail",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modello",
        "name": "Nome",
        "product code": "Codice prodotto",
        "role name": "Nome del ruolo",
        "serial": "Numero seriale",
        "search by": "Ricerca per",
        "search company name": "Cerca nome azienda"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Stai per disattivare l'autenticazione a due fattori. Ciò potrebbe rendere il tuo account FOTA WEB meno sicuro. Sei sicuro di voler continuare?",
                    "title": "Sei sicuro?"
                },
                "send email code": {
                    "enter code": "Per motivi di sicurezza, inserisci il codice per verificare l'indirizzo e-mail."
                },
                "send otp code": {
                    "description": "Un codice a 6 cifre è stato inviato alla tua app di autenticazione. Per motivi di sicurezza, inserisci il codice generato nel campo sottostante.",
                    "no access": {
                        "authenticator": "Se non hai più accesso all'app di autenticazione collegata a questo account, è necessario modificare la password per disabilitare l'autenticazione a due fattori.",
                        "email": "Se non hai più accesso all'indirizzo e-mail associato a questo account, è necessario modificare la password per disabilitare l'autenticazione a più fattori."
                    }
                },
                "title": "Disattiva l'autenticazione a due fattori"
            },
            "get email code": {
                "description": "Utilizza il codice visualizzato nella schermata successiva per verificare il tuo account.",
                "description modal": "Utilizza quel codice per verificare il tuo account.",
                "title": "Premendo \"Invia codice\", un codice univoco verrà inviato a <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Per completare questa procedura è necessaria un'app mobile di autenticazione, come una delle seguenti:"
            },
            "select authentication type": {
                "authentication app description": "Ottieni un codice univoco da un'app come Microsoft Authenticator o Google Authenticator.",
                "description": "Per garantire la sicurezza del tuo account e dei dati dei tuoi clienti, utilizza una delle seguenti opzioni per configurare l'autenticazione a due fattori.",
                "description modal": "Seleziona il tuo metodo di autenticazione preferito.",
                "email": "E-mail",
                "email description": "Ti invieremo un codice monouso alla tua email ogni volta che proverai ad accedere.",
                "recommended": "Consigliato",
                "title": "L'autenticazione a due fattori (2FA) è obbligatoria per tutti gli utenti FOTA WEB.",
                "title modal": "Seleziona il metodo di autenticazione"
            },
            "send email code": {
                "description": "Inserisci il codice nel campo sottostante e premi \"Verifica\" per procedere.",
                "enter code": "Inserisci il codice per verificare l'indirizzo e-mail.",
                "title": "Un codice univoco è stato inviato a <1>{{email}}</1>.",
                "verification code": "Codice di verifica"
            },
            "send otp code": {
                "click to scan code": "Clicca qui per scansionare un codice QR",
                "click to type code": "Clicca qui per inserire manualmente il codice",
                "incorrect code": "Codice errato",
                "scan QR code": "Scansiona il codice QR nella tua app",
                "six digit code": "Codice a 6 cifre generato dalla tua app",
                "title": "Per completare questo processo è necessaria un'app mobile di autenticazione, come <1>Microsoft Authenticator</1> o <2>Google Authenticator</2>.",
                "type text code": "Digita il codice di testo nella tua app"
            },
            "settings": {
                "description": "L'autenticazione a due fattori è un ulteriore livello di sicurezza che verifica la tua identità con qualcosa che conosci (password) e qualcosa che possiedi (telefono, chiave di sicurezza, e-mail).",
                "disabled": "Disabilitato",
                "enabled": "Abilitato",
                "title": "Autenticazione a due fattori"
            },
            "success message": {
                "alert": "Autenticazione a due fattori abilitata con successo.",
                "description": "Ti chiederemo un codice di autenticazione ogni volta che effettuerai l'accesso con la tua e-mail e la tua password.",
                "title": "Hai abilitato con successo l'autenticazione a due fattori.",
                "title modal": "Autenticazione a due fattori abilitata!"
            },
            "title": {
                "authentication app": "App di autenticazione",
                "authentication email": "Email di autenticazione",
                "is enabled": "Autenticazione a due fattori abilitata.",
                "protect your account": "Proteggi il tuo account FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Modifica password",
            "enter current password": "Inserisci la password attuale",
            "enter new password": "Inserisci nuova password",
            "hide password": "Nascondi password",
            "repeat new password": "Ripeti la nuova password",
            "rules": {
                "lowercase letter": "Almeno una lettera minuscola (a-z)",
                "minimum characters": "Almeno 12 caratteri",
                "new and current passwords must not match": "Le password nuove e quelle attuali non devono corrispondere",
                "new passwords must match": "Le nuove password devono corrispondere",
                "number": "Almeno un numero",
                "passwords must match": "Le password devono corrispondere",
                "special symbol": "Almeno un simbolo speciale (!@#$%^&*()-_=+)",
                "uppercase letter": "Almeno una lettera maiuscola (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Mostra password"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Statistiche",
        "statistics message": "I filtri della tabella influiranno sulle statistiche visualizzate di seguito",
        "activity": "Attività",
        "model": "Modello",
        "firmware": "Firmware",
        "configuration": "Configurazione",
        "statistics": "Statistiche"
    },
    "Table": {
        "1_wire_authorization": "Autorizzazione 1-Wire",
        "access group": "",
        "access groups": "",
        "access level": "Livello di accesso",
        "accessories": "Accessori",
        "action": "Azione",
        "action date": "Data dell'azione",
        "assigned package": "Pacchetto assegnato",
        "attempt count": "Conteggio dei tentativi",
        "attribute": "Attributo",
        "attributes": "Attributi",
        "auto sync": "",
        "batch id": "ID batch",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "Autorizzazione Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adattatore CAN",
        "can adapter name": "Nome dell'adattatore CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Pacchetto file OEM",
        "can oem file vehicle": "File OEM veicolo",
        "can package": "Pacchetto CAN",
        "can program number": "Numero programma CAN",
        "can software date": "Data software CAN",
        "can type": "Tipo CAN",
        "carrier module id": "ID modulo",
        "carrier revision": "Revisione",
        "carrier serial id": "ID seriale",
        "carrier settings filename": "Nome del file delle impostazioni",
        "carrier unit status": "Stato",
        "carrier unit type": "Tipo di unità",
        "changed at": "Modificato alle",
        "change origin": "",
        "changes": "Modifiche",
        "checkbox disabled": {
            "role": "I ruoli statici non possono essere modificati o eliminati."
        },
        "child company": "<0>Società controllata da</0><1>{{parentCompany}}</1>",
        "child companies": "Società controllate",
        "code": "Codice",
        "company": "Azienda",
        "company hierarchy": "Gerarchia aziendale",
        "company name": "Nome dell'azienda",
        "compatibility": "Compatibilità",
        "configuration": "Configurazione",
        "configuration details": "Dettagli di configurazione",
        "configuration type": "",
        "created at": "Creato presso",
        "created by": "Creato da",
        "date": "Data",
        "description": "Descrizione",
        "device details": "Dettagli del dispositivo",
        "device company": "Azienda produttrice di dispositivi",
        "device description": "Descrizione del dispositivo",
        "device group": "Gruppo di dispositivi",
        "device imei": "IMEI del dispositivo",
        "device model": "Modello del dispositivo",
        "device seen at": "Dispositivo visto il",
        "device serial": "Numero seriale del dispositivo.",
        "devices": "Dispositivi",
        "devices count": "Numero di dispositivi",
        "Done": "Fatto",
        "download at": "",
        "download file": "Scarica file",
        "dtb": "DTB",
        "edit file": "Modifica file",
        "email": "E-mail",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Non appena vengono creati i gruppi di attività, potrai visualizzarne l'elenco qui",
                    "changes": "Non appena vengono apportate modifiche, potrai visualizzare l'elenco qui",
                    "companies": "Non appena le aziende saranno state create, potrai visualizzare l'elenco qui",
                    "configurationChanges": "",
                    "desktopLicenses": "Non appena saranno state create le licenze desktop, potrai visualizzare l'elenco qui",
                    "devices": "Non appena i dispositivi vengono caricati su FOTA WEB, potrai visualizzarne l'elenco qui",
                    "files": "Non appena i file vengono caricati, potrai visualizzare l'elenco qui",
                    "groups": "Non appena i gruppi saranno stati creati, potrai visualizzare l'elenco qui",
                    "offlineLicenses": "Non appena vengono create le licenze offline, potrai visualizzare l'elenco qui",
                    "permissions": "Non appena le autorizzazioni saranno assegnate all'utente, potrai visualizzare l'elenco qui",
                    "productCodes": "Non appena i codici prodotto saranno stati creati, potrai visualizzare l'elenco qui",
                    "roles": "Non appena i ruoli saranno stati creati, potrai visualizzare l'elenco qui",
                    "tasks": "Non appena vengono creati i compiti, potrai visualizzarne l'elenco qui",
                    "users": "Non appena gli utenti vengono aggiunti, potrai visualizzare l'elenco qui"
                },
                "title": {
                    "batches": "La tabella dei gruppi di attività è vuota",
                    "changes": "La tabella delle modifiche è vuota",
                    "companies": "La tabella delle aziende è vuota",
                    "configurationChanges": "",
                    "desktopLicenses": "La tabella delle licenze desktop è vuota",
                    "devices": "La tabella dei dispositivi è vuota",
                    "files": "La tabella dei file è vuota",
                    "groups": "La tabella dei gruppi è vuota",
                    "offlineLicenses": "La tabella delle licenze offline è vuota",
                    "permissions": "La tabella delle autorizzazioni è vuota",
                    "productCodes": "La tabella dei codici prodotto è vuota",
                    "roles": "La tabella dei ruoli è vuota",
                    "tasks": "La tabella delle attività è vuota",
                    "users": "La tabella degli utenti è vuota"
                }
            },
            "no permission": {
                "description": "Contatta il tuo amministratore per richiedere l'accesso.",
                "title": "Non disponi dei permessi necessari per visualizzare questo contenuto"
            },
            "no results found": {
                "description": "Prova un'altra parola chiave o un altro filtro per ottenere risultati",
                "title": "Nessun risultato trovato"
            },
            "button": {
                "add": {
                    "companies": "Crea azienda",
                    "devices": "Aggiungi dispositivo",
                    "files": "Carica file",
                    "groups": "Crea gruppo",
                    "productCodes": "Aggiungi codice prodotto",
                    "tasks": "Crea attività",
                    "users": "Invita utente"
                },
                "reset view": "Reimposta visualizzazione"
            }
        },
        "exausted autoscan limit": "Limite di scansione automatica esaurito fino al",
        "exausted vin parsing limit": "Limite di analisi VIN esaurito fino al",
        "expiration": "Scadenza",
        "expiration date": "Data di scadenza",
        "expires at": "Scade il",
        "expiry date": "Data di scadenza",
        "field": "Campo",
        "file": "File",
        "file id": "ID file",
        "files": "File",
        "file type": "Tipo di file",
        "filter by": "Filtra per",
        "firmware": "Firmware",
        "general": "Generale",
        "general data": "Dati generali",
        "gnss version": "Versione GNSS",
        "group": "Gruppo",
        "groups": "Gruppi di dispositivi",
        "group vip status": "",
        "gsm number": "Numero GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "Piattaforma FMx - modelli FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) e TMT.",
                "ft platform": "Piattaforma FT - modelli FTx e ATx.",
                "legacy platform": "<1>Piattaforma legacy</1> - modelli FM (esclusi FM4001 e FM3010), FMA e GH (GH4000).",
                "title": "Generazione della piattaforma del dispositivo telematico"
            },
            "visibility": "<2>Le modifiche contrassegnate come <1>Interne</1> non sono visibili ai clienti.</2><2>Poiché le modifiche ai dispositivi possono includere sia dati visibili che nascosti, <1>non condividere screenshot o dettagli nelle comunicazioni esterne</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Info",
        "interface": "Interfaccia",
        "invited by": "Invitato da",
        "items": "elementi",
        "last checked at": "Ultimo controllo effettuato il",
        "last sign in": "Ultimo accesso",
        "last status update": "Ultimo aggiornamento dello stato",
        "last used at": "Utilizzato l'ultima volta alle",
        "license disabled": "Disabilitato",
        "license enabled": "Abilitato",
        "license key": "Chiave di licenza",
        "license name": "",
        "links": "Link",
        "manual_geofence_scenarios": "Scenari di geofence manuali",
        "message": "Messaggio",
        "model": "Modello",
        "model task type support": {
            "false": "Non supportato",
            "true": "Supportato"
        },
        "modem version": "Versione modem",
        "name": "Nome",
        "new value": "Nuovo valore",
        "next task": "Prossima attività",
        "no changes": "Nessuna modifica.",
        "no company name": "Nessun nome aziendale",
        "no details": "Nessun dettaglio",
        "no file": "Nessun file",
        "no imei available": "IMEI non disponibile",
        "no model": "Nessun modello",
        "no parent company": "L'azienda non ha una società madre.",
        "no tasks": "Il dispositivo non ha compiti.",
        "number": "Numero",
        "obd": "OBD",
        "obd chip firmware version": "Versione firmware chip OBD",
        "of": "di",
        "offline licenses tab disabled": "Le licenze offline non sono disponibili per le licenze desktop disabilitate.",
        "origin": "",
        "original value": "Valore originale",
        "other information": "Altre informazioni",
        "page of": "pagina di",
        "parent company": "Società madre",
        "permission count": "Conteggio delle autorizzazioni",
        "platform": "Piattaforma",
        "Price": "Prezzo",
        "product code": "Codice prodotto",
        "program number": "Numero di programma",
        "property": "Proprietà",
        "queue": "Coda",
        "receiving company": "Azienda ricevente",
        "revision": "Revisione",
        "role": "Ruolo",
        "role name": "Nome del ruolo",
        "rows per page": "Righe per pagina",
        "running": "In esecuzione",
        "schedule": "Pianificazione",
        "seen at": "Visto il",
        "select row": "Seleziona una riga per visualizzare i dettagli",
        "send sms": "Invio di SMS",
        "serial": "Numero seriale",
        "show details": {
            "desktopLicenses": "Mostra i dettagli della licenza desktop",
            "devices": "Mostra i dettagli del dispositivo",
            "batches": "Mostra i dettagli del gruppo di attività",
            "tasks": "Mostra i dettagli dell'attività",
            "companies": "Mostra i dettagli dell'azienda"
        },
        "sim": "SIM",
        "size": "Dimensioni",
        "software date": "Data del software",
        "source company": "Azienda di origine",
        "spec_id": "Spec ID",
        "status": "Stato",
        "status id": "ID stato",
        "status name": "Nome dello stato",
        "supported task types": "Tipi di attività supportati",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Colonne della tabella",
        "target company": "Azienda target",
        "task id": "ID attività",
        "task queue": "Coda delle attività",
        "tasks": "Attività",
        "task type": "Tipo di attività",
        "tct web support": "Assistenza web TCT",
        "total": "Totale",
        "type": "Tipo",
        "updated at": "Aggiornato il",
        "updated by": "Aggiornato da",
        "unknown": "Sconosciuto",
        "user cannot be deleted": "L'utente non può essere eliminato.",
        "user cannot be edited": "L'utente non può essere modificato.",
        "user cannot delete himself": "Un utente non può eliminare il proprio profilo.",
        "user date statuses": {
            "expired": "Scaduto",
            "expires": "Scadenza",
            "never expires": "Non scade mai",
            "sent": "Inviato"
        },
        "user email": "E-mail dell'utente",
        "user invitation cannot be cancelled": "L'invito dell'utente non può essere annullato.",
        "user invitation cannot be resent": "L'invito all'utente non può essere inviato nuovamente.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Attivo",
            "Inactive": "Inattivo",
            "InvitationExpired": "Invito scaduto",
            "InvitationPending": "Invito in sospeso"
        },
        "users": "Utenti",
        "value from": "Dal valore",
        "value to": "Al valore",
        "view all roles": "Visualizza tutto ({{count}})",
        "vin": "VIN",
        "vip status": "Stato VIP",
        "visibility": "Visibilità"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Informazioni sulle autorizzazioni",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Nome dell'interfaccia accessoria.",
                    "type": "tipo di accessorio connesso."
                },
                "can": {
                    "assigned package": "Il pacchetto OEM assegnato al dispositivo.",
                    "can oem file package": "Il pacchetto OEM segnalato durante l'ultima connessione.",
                    "can oem file vehicle": "Configurazione del veicolo OEM segnalata durante l'ultima connessione.",
                    "dtb": "",
                    "firmware": "Versione del firmware CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "L'ultima stringa di avvio dell'adattatore CAN ricevuta contenente i dati correnti e il numero di programma dell'adattatore.",
                    "program number": "Il numero di programma dell'adattatore CAN.",
                    "revision": "",
                    "software date": "Data del software dell'adattatore CAN.",
                    "type": "il tipo di adattatore CAN."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "ultimo nome del file dell'elenco delle autorizzazioni 1-Wire inviato.",
                    "bluetooth_authorization": "ultimo nome del file dell'elenco delle autorizzazioni Bluetooth inviato.",
                    "main configuration": "nome dell'ultimo file di configurazione principale inviato.",
                    "manual_geofence_scenarios": "Nome dell'ultimo file dell'elenco delle geofence manuali inviato."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "La versione del firmware BLE segnalata durante l'ultima connessione.",
                    "bluetooth password": "",
                    "bootloader": "La versione del bootloader del dispositivo segnalata durante l'ultima connessione.",
                    "company": "l'azienda proprietaria di questo dispositivo.",
                    "configuration": "nome dell'ultimo file di configurazione inviato.",
                    "description": "Descrizione del dispositivo (definita dall'utente).",
                    "dtb": "La versione del blob dell'albero dei dispositivi segnalata durante l'ultima connessione.",
                    "firmware": "La versione del firmware del dispositivo segnalata durante l'ultima connessione.",
                    "gnss version": "la versione del GNSS segnalata durante l'ultima connessione.",
                    "group": "Il gruppo di dispositivi a cui è assegnato questo dispositivo.",
                    "product code": "il codice prodotto del dispositivo.",
                    "serial": "il numero seriale del dispositivo."
                },
                "obd": {
                    "obd chip firmware version": "La versione del firmware del chip OBD segnalata durante l'ultima connessione.",
                    "vin": "Codice unico di 17 caratteri che identifica un determinato veicolo a motore."
                },
                "sim": {
                    "gsm number": "Il numero di telefono pubblico associato a un dispositivo.",
                    "iccid": "Numero seriale univoco che identifica una scheda SIM.",
                    "imsi": "Identificatore univoco per un abbonato a una rete mobile."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "data e ora di creazione dell'utente.",
                    "id": "ID univoco dell'utente.",
                    "invited by": "Indirizzo e-mail dell'utente che ha creato l'invito.",
                    "role": "ruoli assegnati all'utente.",
                    "updated at": "data e ora dell'ultimo aggiornamento dell'utente."
                }
            }
        },
        "user details": "Dettagli utente"
    },
    "Task groups": {
        "all": "Tutto",
        "bulk type": {
            "CompanyBulkDelete": "Elimina azienda",
            "DeviceBulkCreate": "Aggiungi dispositivo",
            "DeviceBulkDelete": "Elimina dispositivo",
            "DeviceBulkUpdate": "Aggiornamento del dispositivo",
            "FileBulkDelete": "Elimina file",
            "GroupBulkDelete": "Elimina gruppo",
            "TaskBulkCreate": "Crea attività",
            "TaskBulkUpdate": "Annulla attività",
            "UserBulkDelete": "Elimina utente"
        },
        "pending approval": "In attesa di approvazione",
        "already approved": "Già approvato",
        "no approval required": "Non è richiesta alcuna approvazione",
        "total objects": "Oggetti totali",
        "total tasks": "Totale attività"
    },
    "Task status": {
        "0": "In attesa di approvazione",
        "1": "In esecuzione",
        "2": "Completato",
        "3": "Completato con errori",
        "4": "Annullato",
        "5": "Non riuscito",
        "6": "Scaduto",
        "7": "In attesa di approvazione",
        "8": "Verifica",
        "task count": {
            "0": "Attività in sospeso",
            "1": "Esecuzione delle attività",
            "3": "Completato con attività errate",
            "5": "Attività non riuscite"
        },
        "verified tooltip title": "L'attività è stata completata con successo e verificata dal dispositivo."
    },
    "Tasks": {
        "0": "L'attività è in coda ed è ora in sospeso.",
        "1": "L'attività è attualmente in esecuzione.",
        "2": "L'attività è stata completata con successo.",
        "3": "L'attività è stata completata, ma si sono verificati alcuni errori.",
        "4": "L'attività è stata annullata.",
        "5": "L'operazione non è andata a buon fine.",
        "6": "L'attività non è stata completata entro un determinato periodo di tempo."
    },
    "Tct": {
        "edit configuration": "Modifica configurazione",
        "no editable configurations": "Non vengono caricati configurazioni modificabili",
        "open tct": "Versione web TCT web",
        "open tct description": "Scegli di creare una nuova configurazione nella versione TCT web o modifica un file di configurazione esistente da FOTA WEB.",
        "select configuration file": "Seleziona un file di configurazione che desideri modificare in TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "La versione TCT web è disponibile solo per il livello aziendale Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
